const language = [
  // English
  {
    'username': 'Username',
    'password': 'Password',
    'submitBtn': 'Login',
    'forgotpass': 'I forgot my password',
    'cookiepolicy': 'Cookie Policy',
    'californiasupply': 'California Supply Chains Act',
    'privacypolicy': 'Privacy Policy',
    'useragreement': 'User Agreement',
    'loginattemptsnumber': 'Login attempts ',
    'loginattemptsexceeded': 'Login attempts exceeded please try your request at a later time',
    'emailaddress': 'Email Address:',
    'userEmail': 'User Email Address',
    'resetpassBtn': 'Reset Password',
    'internalservererror': 'Internal Server Error',
    'internalservererrorP1': 'An internal error occured while processing your request.',
    'internalservererrorP2': 'The system administrator has been notifed and is working to resolve this issue as quickly as possible.',
    'internalservererrorP3': 'Should you continue to experience difficulty loading this page, please contact support directly.',
    'usernameinvalid': 'Username is invalid. Please try again',
    'invalidcredentials': 'Invalid credentials supplied. Please try again',
    'passwordblank': 'Password may not be blank. Please try again',
    'loginattemptinvalid': 'Login Attempt Invalid. The system administrator has been notified.',
    'loginfail': 'Login fail. The username or password you entered was not found in our system. If this problem persists please contact your system administrator.',
    'emailblank': 'Email address may not be blank.',
    'emailinvalid': 'Email address is invalid. Please try again',
    'emailconfirm': 'Please confirm your email address.',
    'passwordsize': 'Password must be between 8 and 16 characters in length.',
    'passworduppercase': 'Password must contain at least 1 uppercase character.',
    'passwordlowercase': 'Password must contain at least 1 lowercase character.',
    'passwordnumber': 'Password must contain at least 1 number.',
    'passwordcontainblank': 'Password may not contain blank spaces.',
    'blankfirst': 'Please provide your first name.',
    'blanklast': 'Please provide your last name.',
    'blankcompany': 'Please provide your company name.',
    'blankstate': 'Please provide your state.',
    'blankavante': 'Please provide your Avante number.',
    'blankterms': 'Please accept terms and conditions to proceed.',
    'blankshareddata': 'Please accept or decline the shared data agreement.',
    'emailnomatch': 'Email address do not match.',
    'passwordnomatch': 'Passwords do not match.',
    'emailused': 'Email address is already in use.',
    'usersignupsuccess': 'User Sign Up Successful',
    'usersignupactivate': "You're almost done. Please check your email to activate your new account.",
    'loginsexceed': 'Logins Exceeded',
    'confirmemailaddress': 'Confirm Email address:',
    'passwordcolon': 'Password:',
    'confirmpasswordcolon': 'Confirm Password:',
    'firstname': 'First Name',
    'lastname': 'Last Name',
    'avantenum': 'Avante Number',
    'companyname': 'Company Name',
    'companystate': 'Company State:',
    'emailaddresscolon': 'Email address:',
    'confirmemailaddresscolon': 'Confirm Email address:',
    'shareddata': 'Shared Data ',
    'agreement': 'Agreement',
    'accept': 'Accept',
    'decline': 'Decline',
    'usernotfound': "The user record you're trying to activate was not found.",
    'clickhere': 'Click here',
    'tologintoyouacct': 'to login to your account.',
    'useracctactivated': 'User Account Activated',
    'passwordlinkinvalid': 'Password link invalid. Please try your request again.',
    'passwordexpire': 'Password link expired. Please try your request again.',
    'passwordresetconfirm': 'Password Reset Confirmed',
    'please': 'Please',
    'login': 'login',
    'toyouraccount': 'to your account.',
    'newpassword': 'New Password:',
    'passwordrequirements': 'Password Requirements',
    'lengthofpasswordLi': 'The length of the password must be at least eight (8) characters and not more than sixteen (16) characters.',
    'passwordblankLi': 'The password may not contain blank spaces.',
    'passwordgroupsLi': 'The password must contain at least one (1) character from each of the three (3) groups below:',
    'passwordgroupupperLi': 'English uppercase characters (A through Z)',
    'passwordgrouplowerLi': 'English lowercase characters (a through z)',
    'passwordgroupnumberLi': 'Numerals (0 through 9)',
    'passResetSent': 'Password Reset Request Sent',
    'pleasecheckemailresetpass': 'Please check your email to reset your password.',
    'passresetchangeEmail': "We have received a password change request for your HME CLOUD account: If you made this request, then please click on the link below or by pasting it into your browser's address bar. http://#APPLICATION.rootURL#/?pg=ManageAccount&st=rl&ruid=#Reset_UID# This link will work for 2 hours or until you reset your password. If you did not ask to change your password, then please ignore this email. Another user may have entered your username by mistake. No changes will be made to your account. The HME CLOUD team",
    'homepageNewFeatures': 'HME CLOUD has been updated with new features! ',
    'homepageNewFeaturesLink': 'Learn more',
    'homepageMaintenanceMessage': 'HME CLOUD will be maintained on',
    'homepageWebsiteAndLeaderboardMaintenance': 'The display of the Web site and the ranking in store will be temporarily unavailable',
    'homepageLeaderboardMaintenance': 'In-store ranking display will be temporarily unavailable',
    'homepageWelcomeMessage': 'Welcome to the HME CLOUD, ',
    'homepageStores': 'Stores',
    'homepageStoresDescription': 'View ZOOM settings for each store and access live dashboards.',
    'homepageUsers': 'Users',
    'homepageUsersDescription': "Add new users or modify existing users' contact information and access to the store.",
    'homepageMyAccount': 'Accounts',
    'homepageMyAccountDescription': 'Change the contact information for your account and change your username and password.',
    'trainingBannerLearnMore': 'HME Training Portal',
    'trainingBannerDescription': 'Find videos, supporting documents and other training guides.',
    'trainingBannerPortalLink': 'Visit the HME Training Portal >',
    'headerLoggedInAs': 'Logged in as ',
    'headerSignOut': 'Sign Out',
    'navbarWelcome': 'Welcome',
    'navbarDashboard': 'Dashboard',
    'navbarReports': 'Reports',
    'navbarMyAccount': 'My Account',
    'navbarSettings': 'Settings',
    'pleasecheckemailreport': 'Please check your email. Your Report has been sent to ',
    'summaryReport': 'Summary Reports',
    'brand': 'Brand',
    'store': 'Store',
    'warningselect250stores': 'You may select up to 250 stores.',
    'warningselect100stores': 'You cannot exceed the default date range for reports with more than 100 stores.',
    'warningbigoperation': 'Warning: 100+ store reports will take a while before being emailed to you.',
    'warning100Plus': 'Warning: 100+ store report will generate an email with CSV file.',
    'timemeasure': 'Time Measure',
    'warningselect1stores': 'You may select only 1 store for Raw Data Reports.',
    'from': 'From',
    'to': 'To',
    'advancedoptions': 'Advanced Options',
    'open': 'Open',
    'close': 'Close',
    'OPEN-CLOSE': 'OPEN - CLOSE',
    'type': 'Type',
    'tempIdentification': 'The temporary identification code can be located in the body of the identification code email. The temporary code will expire 5 minutes after the email has been sent and will only be valid for a single use.',
    'timeslice': 'Time Slice',
    'cumulative': 'Cumulative',
    'reportsadvancedreport': '*Reports including Advanced Options are generated by CSV and sent by email.',
    'include': 'Include',
    'exclude': 'Exclude',
    'longesttimes': 'Longest Times',
    'systemstats': 'System Statistics',
    'format': 'Format',
    'secondswformat': 'Seconds (sec)',
    'minuteswformat': 'Minutes (min:sec)',
    'secondsShort': '(sec)',
    'minutesShort': '(min:sec)',
    'savedreporttemplates': 'Saved Report Templates',
    'generatereport': 'Generate Report',
    'criteria': 'Criteria',
    'stores': 'Stores',
    'saveastemplate': 'Save as Template',
    'namethistemplate': '(Name this template)',
    'hmeclouddashbord': 'HME CLOUD DASHBOARD',
    'rankingaccurate': 'Ranking accurate as of',
    'goal': 'Goal',
    'current': 'Current',
    'previous': 'Previous',
    'full': 'Full',
    'rank': 'Rank',
    'ranking': 'Ranking',
    'offline': 'offline',
    'Unavailable': 'Unavailable',
    'cars': 'Cars',
    'avg': 'Avg',
    'pullins': 'pullins',
    'includes': 'includes',
    'excludes': 'excludes',
    'thedata': 'The data',
    'customizedashboard': 'Customize Dashboard',
    'enableautorefresh': 'Enable Auto Refresh',
    'disableautorefresh': 'Disable Auto Refresh',
    'custom': 'Custom',
    'month': 'Month',
    'Month': 'Month',
    'week': 'Week',
    'Week': 'Week',
    'day': 'Day',
    'Day': 'Day',
    'daypart': 'Daypart',
    'hour': 'Hour',
    'Hour': 'Hour',
    'rollinghour': 'Rolling Hour',
    'dashboardbeinggenerated': 'Please wait while your dashboard is being generated...',
    'dashboardtakeawhile': 'Please Note: This dashboard may take a while to load depending on the amount of data being requested.',
    'rawdatareport': 'Raw Data Report',
    'none': 'None',
    'accountinfo': 'Account Information',
    'recordsaved': 'Selection saved.',
    'userinfo': 'User Information',
    'user name': 'User Name:',
    'user': 'User',
    'User': 'User',
    'UnableToConnect': 'Unable to Connect',
    'role': 'Role',
    'userstoreaccess': 'User Store Access:',
    'passchangereq': 'Password change required',
    'currentpassword': 'Current Password:',
    'confirmnewpassword': 'Confirm New Password:',
    'jobtitle': 'Job Title:',
    'officenum': 'Office Number:',
    'mobilephone': 'Mobile Phone:',
    'fax': 'Fax:',
    'termagreementreq': 'Terms Agreement required',
    'agreetohme': "I agree to HME's",
    'termsofservice': 'terms of service',
    'sharedatawithcorp': 'Share Data With Corporate',
    'shared': 'Shared',
    'notshared': 'Not Shared',
    'cancel': 'Cancel',
    'save': 'Save',
    'companyinfo': 'Company Information',
    'address1': 'Address Line 1',
    'address2': 'Address Line 2',
    'address3': 'Address Line 3',
    'address4': 'Address Line 4',
    'city': 'City:',
    'country': 'Country:',
    'state': 'State',
    'selstate': '***Select Your State***',
    'usterrcomm': '***US Territores/Commonwealth***',
    'zip': 'Zip:',
    'region': 'Region',
    'distributor': 'Distributor:',
    'phone': 'Phone:',
    'users': 'Users',
    'addauser': 'Add a User',
    'addanaccount': 'Add an account',
    'expiredaccouts': 'Expired accounts',
    'accountrenewal': 'Account renewals',
    'freeaccounts': 'Free accounts',
    'viewedit': 'View/Edit',
    'userdetails': 'User Details',
    'usernameemail': 'Username(Email Address):',
    'removeuser': 'Remove User',
    'areyousureremoveuser': 'Are you sure you want to remove this user?',
    'areyousuredeleterole': 'Are you sure you want to delete this role?',
    'areyousureremovegroup': 'Are you sure you want to remove this leaderboard?',
    'confirmToDelete': 'Confirm to Delete',
    'ConfirmationRequired': 'Confirmation Required',
    'CIBSystem_Remove_Popup_Message':'Are you sure you would like to remove the selected system?',
    'yes': 'Yes',
    'no': 'No',
    'status': 'Status',
    'inactive': 'inactive',
    'Active': 'Active',
    'Inactive': 'Inactive',
    'userrole': 'User Role:',
    'userAccessLevel': 'User Access Level',
    'storeaccess': 'Store Access:',
    'selectall': 'Select All',
    'deselectall': 'Deselect All',
    'roles': 'Roles',
    'addarole': 'Add a Role',
    'company': 'Company',
    'roledescription': 'Role Description',
    'optional': '(optional)',
    'deleterole': 'Delete Role',
    'Rolehasuser': 'Role',
    'rolename': 'Role Name:',
    'roledetails': 'Role Details',
    'leavetheopencloseboxes': 'Leave the Open and/or Close boxes checked if you want the start and/or end times to remain as configured in the ZOOM timer.  Uncheck the box(es) if you want to choose a specific start and/or end time.',
    'choosetimeslice': 'Choose Time Slice if you are only interested in a narrow window of time within each daypart, day, or week.  Use the controls above to choose a start and end time.',
    'choosecumulative': 'Choose Cumulative if you want the report to include everything from the chosen start  date and time to the chosen end date and time.',
    'chooseseconds': 'Choose Seconds if you want your report in seconds.  Choose Minutes if you want your report in minutes:seconds.',
    'selectapreviousreport': 'Select a previously saved report template to run a common report, or select new options and save a new report template to use later.',
    'selectonestore': 'Select one store for a single-store report.  Select multiple stores for a comparison report.',
    'thereportwillsummarize': 'The report will summarize or average the data over the time intervals you choose. For example, choose week if you want all of the days of each rolled up into one-week intervals. Only one store may be selected at a time for a Raw Data Report.',
    'choosestartorend': 'Choose a start and end date for the overall time period of the report. Single store can select any 2 month period. Multiple store can select any 1 month period.',
    'choosestartandend': 'Choose a start and end date for the overall time period of the report. Maximum 100 stores can be selected for 1 month period',
    'settingsStoresBrand': 'Brand',
    'settingsStoresStoreName': 'Store Name',
    'settingsStoresStoreNumber': 'Store Number',
    'settingsStoresAddressLineOne': 'Address Line 1',
    'settingsStoresAddressLineTwo': 'Address Line 2',
    'settingsStoresAddressLineThree': 'Address Line 3',
    'settingsStoresAddressLineFour': 'Address Line 4',
    'settingsStoresStoreCity': 'City',
    'settingsStoresStoreState': 'State:',
    'settingsStoresStoreRegion': 'Region',
    'settingsStoresZip': 'Zip:',
    'settingsStoresCountry': 'Country:',
    'settingsStoresPhone': 'Phone:',
    'settingsStoresFax': 'Fax:',
    'settingsStoresCancel': 'Cancel',
    'settingsStoresRegisteredSystems': 'Registered Systems',
    'settingsStoresSystemName': 'System Name',
    'settingsStoresSystemVersion': 'System Version',
    'settingsStoresSerialNumber': 'Serial Number',
    'settingsStoresSystemStatus': 'System Status',
    'settingsStoresOnline': 'Online',
    'settingsStoresOffline': 'Offline',
    'settingsStoresNotAvailable': 'Not Available',
    'settingsStoresViewDetails': 'View Details',
    'storeSettingsConfirmUpdateSucessful': 'Update Successful!',
    'storeSettingsConfirmError': 'The following errors occured during your request:',
    'storeSettingsConfirmTransferSucessful': 'Transfer Successful!',
    'storeSettingsConfirmFiveMinuteNotice1': 'Please Note:',
    'storeSettingsConfirmFiveMinuteNotice2': 'The settings changes will take approximately 5 minutes to take effect.',
    'storeSettingsConfirmUpgradeSucessful': 'Upgrades Successful!',
    'storeListRecordSaved': 'Record Saved!',
    'storeListRecordRemoved': 'Record Removed!',
    'storeListStores': 'Stores',
    'storeListStoreDetails': 'Store Details',
    'settingsStoresCIBSettings': 'CIB Settings',
    'settingsStoresCIBEmail': 'Email:',
    'settingsStoresCIBBrand': 'Brand',
    'settingsStoresCIBTimeZone': 'Time Zone: ',
    'settingsStoresRegisteredCIB': 'Registered CIB',
    'settingsStoresRegisteredEOS': 'Registered EOS',
    'settingsStoresRegisteredION': 'Registered ION',
    'settingsStoresRegisteredZOOM': 'Registered ZOOM',
    'settingsStoresCorporateStore': 'Corporate Store',
    'settingsStoresNoStores': 'You have no stores',
    'settingsStoresLoadingMessage1': 'Please wait while your request is being processed...',
    'settingsStoresLoadingMessage2': 'Please Note: This may take a while to load depending on the amount of data being requested.',
    'settingsStoresAreYouSure': 'Are you sure you would like to update the selected store(s)?',
    'settingsStoresDetails': 'Details',
    'settingsUsersDetails': 'User',
    'settingsStoresUnavailable': 'Unavailable',
    'secondswithabb': 'Seconds (sec)',
    'minuteswithabb': 'Minutes (min:sec)',
    'SelectAStore': 'Select a Store',
    'savesuccessful': 'Save Successful!',
    'pleasefillinfirstname': "Please fill in the user's first name.",
    'pleasefillinlastname': "Please fill in the user's last name.",
    'new': 'New',
    'confirmed': 'Confirmed',
    'passwordnotmatchsystem': 'The password does not match our system.',
    'selectallapply': 'Select all that apply',
    'pleaseassignrole': 'Please assign a role to this user.',
    'selectuserstatus': "Please select the user's status.",
    'useremailalready': 'User email address already in use.',
    'rolenotfound': 'Role not found.',
    'userrecordnotfound': 'User record not found.',
    'willrecieveemail': 'will receive an email containing the necessary login information.',
    'theuser': 'The user',
    'download': 'Download',
    'companyblank': 'Company name may not be blank.',
    'companyaddressblank': 'Please fill in your company address.',
    'companycityblank': 'Please fill in your company city.',
    'zipcodeblank': 'Please provide your zip code.',
    'zipcodeinvalid': 'Please provide a valid zip code.',
    'companyphoneblank': 'Please provide your company phone number.',
    'settingsStoresErrorPickBrand': 'Please pick a brand.',
    'settingsStoresErrorNeedsStoreNum': 'Please fill in your store number.',
    'settingsStoresErrorNeedsAddress': 'Please fill in your store address.',
    'settingsStoresErrorNeedsCity': 'Please fill in your store city.',
    'settingsStoresErrorNeedsState': 'Please provide your state.',
    'settingsStoresErrorNeedsZip': 'Please provide your zip code.',
    'settingsStoresErrorNeedsZip2': 'Please provide a valid zip code.',
    'settingsStoresErrorNeedsNumber': 'Please provide your store phone number.',
    'settingsStoresErrorNeedsNewAddress': 'This address is already in use. Please provide a unique address.',
    'storeSettingsConfirmDeletion': 'Are you sure you want to delete this store?\nThis action cannot be undone.',
    'StoreSettingsHeaderBrand': 'Brand',
    'StoreSettingsHeaderStore': 'Store',
    'StoreSettingsHeaderAddress': 'Store Address',
    'StoreSettingsHeaderCityState': 'City, State',
    'StoreSettingsHeaderName': 'System Name',
    'StoreSettingsHeaderVersion': 'System Version',
    'StoreSettingsHeaderStatus': 'System Status',
    'StoreSettingsErrorSelectionInvalid': 'Please select a valid store.',
    'StoreSettingsErrorNameInvalid': 'Please enter an appropriate Store Name.',
    'StoreSettingsErrorProcessing': 'There has been an error processing your request, please try again later.',
    'StoreSettingsErrorReachingQueue': 'Queue system unreachable. Please try your request again later.',
    'StoreSettingsErrorSystemOffline': 'System must be online to change system settings.',
    'StoreSettingsErrorMakeSelection': 'You must select 1 or more systems to change settings.',
    'systemSettingsZoomUnreachable': 'Zoom system unreachable. Please try your request again later.',
    'systemSettingsNoSelection': 'You must select 1 or more systems to initiate upgrades.',
    'newFeaturesHeader': 'Save Report Templates',
    'newFeaturesFeature1': "You can now save any report with the new 'Saved Report Templates' feature",
    'newFeaturesFeature2': 'Run a report just as you normally would from the report generator',
    'newFeaturesFeature3': "Check the box next to 'Save as Template' and give the report a name",
    'newFeaturesFeature4': "Click on the 'Generate Report'",
    'newFeaturesFeature5': "The report will now appear underneath your list of 'Saved Report Templates'",
    'newFeaturesFeature6': 'Users may save up to 10 templates.',
    'newFeaturesFeature7': "To rerun a template simply click on the name of the report you wish to view and click on 'Generate Report'",
    'newFeaturesMajorHeader': 'New Features in the HME CLOUD',
    'dashboardcustomization': 'Dashboard Customization Successful!',
    'pleaseselectdashboard': 'Please select a valid Dashboard.',
    'pleaseselectdashboardorder': 'Please select a valid Dashboard Order.',
    'deleteroledialog': 'Are you sure you want to delete this role?\nThis action cannot be undone.',
    'rolehasuser': 'cannot be deleted with users assigned to it. Please re-assign these (1) users before deleteing this role.',
    'savechanges': 'Save Changes',
    'confirm': 'Confirm',
    'userremoved': 'User Removed!',
    'leaderboardsettings': 'Leaderboard Settings',
    'resettodefaults': 'Reset to defaults',
    'customizeleaderboard': 'Customize Leaderboard',
    'createcustombyselecting': 'To create a customized dashboard, begin by selecting a time measurement',
    'usingplussign': 'using the plus sign in an open column.',
    'toremovekpi': 'To remove a KPI',
    'fromatimemeasurement': "from a time measurement, click on the icon next to the KPI you'd like to remove.",
    'addkpiuseplus': 'To add a KPI, use the small plus sign inside of the time measurement you are configuring.',
    'youmayselectdefault': 'You may also select a default KPI to establish the ranking of all your stores by using the icon next to the KPI you wish to use.',
    'torearrangetimemeasurement': 'To rearrange any time measurement or KPI within a given time measurement simply click on the column heading you want to move and dragging it to a new location.',
    'validtimemeasure': 'Valid time measurements are Current Hour, Current Daypart, Current Day, Rolling Hour, Previous Hour, Previous Daypart, Previous Day and Previous Rolling Hour.',
    'validkpicars': 'Valid Key Performance Indicators (KPI) are Cars, Avg and Goal%.',
    'carsaretotalnumber': 'Cars are the total number of cars that have been counted during for its respective time measurement; Avg is the average total 1 time for its respective time measurement; and Goal% is the percentage of cars that have come in underneath their Goal A times for its respective time measurement. ',
    'primarygoalcolors': 'Primary Goal Colors',
    'selectcustomgoalcolor': 'Select a custom goal color for your master A, B and over B goals by using the color pickers',
    'thesecolorsallow': 'These colors will allow you to easily identify the performance metrics for each of your stores.',
    'youcanmanuallyenterhex': 'You can also manually enter the hexadecimal value of the color if you prefer.',
    'timeformat': 'Time Format',
    'selectdefaulttime': 'Select the default time format',
    'thatwillbeshowndashboard': 'that will be shown on your dashboards and reports.',
    'timeformatmaybeshown': 'Time format may be shown in minutes:seconds or in seconds.',
    'Pullins': 'Pull-ins',
    'fordashchoosepull': 'For dashboards and reports, you can choose to either include pull-in',
    'dataorexclude': 'data or exclude it.',
    'apullinisavehicle': 'A pull-in is a vehicle that entered the drive-thru lane after the first ON detection point, and exited through the last ON detection point.',
    'language': 'Language',
    'changethelanguage': 'Change the language.',
    'seconds': 'Seconds',
    'minutesseconds': 'Minutes:Seconds',
    'currentrollinghour': 'Current Rolling Hour',
    'Stores': 'Stores',
    'Current Hour': 'Current Hour',
    'Previous Hour': 'Previous Hour',
    'Current Day': 'Current Day',
    'Previous Day': 'Previous Day',
    'Current Daypart': 'Current Daypart',
    'Previous Daypart': 'Previous Daypart',
    'Current Rolling Hour': 'Current Rolling Hour',
    'current rollinghour': 'Current Rolling Hour',
    'Previous Rolling Hour': 'Previous Rolling Hour',
    'current hour': 'Current Hour',
    'previous hour': 'Previous Hour',
    'current day': 'Current Day',
    'previous day': 'Previous Day',
    'current daypart': 'Current Daypart',
    'previous daypart': 'Previous Daypart',
    'current rolling hour': 'Current Rolling Hour',
    'previous rolling hour': 'Previous Rolling Hour',
    'previous rollinghour': 'Previous Rolling Hour',
    'Rank': 'Rank',
    'Store': 'Store',
    'Name': 'Name',
    'Goal': 'Goal',
    'Cars': 'Cars',
    'Avg': 'Avg',
    'Goal%': 'Goal%',
    'setdefaultsort': 'Set Default Sort',
    'removecolumm': 'Remove Column',
    'leaderboardCustomSuccess': 'Leaderboard Customization Successful! Changes will take effect at next page refresh.',
    'leaderboardResetSuccess': 'Leaderboard Reset Successful! Changes will take effect at next page refresh.',
    'createacustomizeddashboard': 'To create a customized dashboard, begin by selecting a time measurement',
    'usingtheplussign': 'using the plus sign in an open column.',
    'toaddakpi': 'To add a KPI, use the small plus sign inside of the time measurement you are configuring.',
    'youmayalsoselectdefaultKPI': 'You may also select a default KPI to establish the ranking of all your stores by using the icon next to the KPI you wish to use.',
    'rearrangeanytimemeasurement': 'To rearrange any time measurement or KPI within a given time measurement simply click on the column heading you want to move and dragging it to a new location.',
    'validtimemeasurements': 'Valid time measurements are Current Daypart, Current Day, Current Week, Current Month, Previous Daypart, Previous Day, Previous Week and Previous Month.',
    'validkpis': 'Valid Key Performance Indicators (KPI) are Cars, Avg and Goal%.',
    'carsarethetotal': 'Cars are the total number of cars that have been counted during for its respective time measurement; Avg is the average total 1 time for its respective time measurement; and Goal% is the percentage of cars that have come in underneath their Goal A times for its respective time measurement.',
    'Current Week': 'Current Week',
    'Previous Week': 'Previous Week',
    'Current Month': 'Current Month',
    'Previous Month': 'Previous Month',
    'current week': 'Current Week',
    'previous week': 'Previous Week',
    'current month': 'Current Month',
    'previous month': 'Previous Month',
    'selectatleastinecolumn': 'You must select at least one column of data.',
    'error': 'Error!',
    'AddRole': 'Add Role',
    'AddUser': 'Add User',
    'EditRole': 'Edit Role',
    'RemoveUser': 'Remove User',
    'EditStoreBasic': 'Edit Store Basic',
    'EditUser': 'Edit User',
    'RemoteConnect': 'Remote Connect',
    'RemoveRole': 'Remove Role',
    'EditLeaderboard': 'Edit Leaderboard',
    'PerformDeviceRestart': 'Perform Device Restart',
    'ViewAllStores': 'View All Stores',
    'Basic': 'Basic',
    'Admin': 'Admin',
    'Owner': 'Owner',
    'EditDeviceSettings': 'Edit DeviceSettings',
    'rolenameblank': 'Role name may not be blank.',
    'pleaseselectonepermission': 'Please select at least one(1) permission for this role.',
    'rolenameinvalid': 'Role is not valid.',
    'roleremoved': 'Role Removed!',
    'cannotbedeleted': 'cannot be deleted with users assigned to it. Please re-assign these',
    'usersbeforedeleting': 'users before deleting this role.',
    'storerankingbylane': 'Store Ranking by Lane Total AVG Time',
    'top3stores': 'Top 3 Stores',
    'lanetransactions': 'Lane Transactions',
    'TRANSACTIONS': 'TRANSACTIONS',
    'AVG TIME (sec)': 'AVG TIME (sec)',
    'lanetotalavgtime': 'Lane Total Avg Time',
    'Queue': 'Queue',
    'Service': 'Service',
    'Menu Board': 'Menu Board',
    'CURRENT DP': 'CURRENT DP',
    'null': 'null',
    'Lane Total': 'Lane Total',
    'Lane 1 Total': 'Lane 1 Total',
    'Lane 1 Total 2': 'Lane 1 Total 2',
    'Lane 2 Total': 'Lane 2 Total',
    'Lane 2 Total 2': 'Lane 2 Total 2',
    'Average Current': 'Average Current',
    'Status': 'Status',
    'Please wait while your dashboard': 'Please wait while your dashboard is being generated...',
    'Please Note: This dashboard': 'Please Note: This dashboard may take a while to load depending on the amount of data being requested.',
    'Daypart': 'Daypart',
    'Store ': 'Store ',
    'Number': 'Number',
    'bottom3Stores': 'Bottom 3 Stores',
    'invalidreporttemplate': 'Invalid Report Template.',
    'pleaseselectopentime': 'Please select an open time',
    'pleaseselectclosetime': 'Please select a close time.',
    'pleaseselectstore': 'Please select a Store',
    'invalidselectiononestore': 'Invalid selection. Please select no more than 1 store for a Raw Data Report',
    'Please select a Start Date': 'Please select a Start Date',
    'Please select an End Date': 'Please select an End Date',
    'daterangeinvalid3month': 'Date range invalid. For Advanced Options Reports select any 3 month period.',
    'daterangeinvalid2week': 'Date range invalid. For Daypart Reports select any 2 week period.',
    'daterangeinvalid2month': 'Date range invalid. For Week Reports select any 2 month period.',
    'daterangeinvalidmonthreport3month': 'Date range invalid. For Month Reports select any 3 month period.',
    'daterangeinvalidsingleday': 'Date range invalid. For Raw Data Reports select a single day.',
    'daterangeinvalid1month': 'Date range invalid. For Day Reports select any 1 month period.',
    'daterangeinvalidbeyond': 'Date range invalid. Starting date may not be beyond ending date.',
    'storeselectioninvalid1000': 'Store selection invalid. You may select up to 1000 stores from the list below.',
    'storeselectioninvalid100': 'Store selection invalid. You may select up to 100 stores from the list below.',
    'pleaseneteratemplatename': 'Please enter a template name to save a template',
    'savedtemplatelimit': 'You have reached the saved template limit of 10. Please remove an existing template to save a new template',
    'pleaseenterauniquetemplate': 'Please enter a unique template name to save this template',
    'pleasechecksaveastemplate': "Please check the 'Save as Template' box along with a template name to save a template",
    'Rolling Hour': 'Rolling Hour',
    'Previous Full Hour': 'Previous Full Hour',
    'Previous Full Rolling Hour': 'Previous Full Rolling Hour',
    'Previous Full Rollinghour': 'Previous Full Rolling Hour',
    'Previous Full Day': 'Previous Full Day',
    'Previous Full Daypart': 'Previous Full Daypart',
    'Previous Full Week': 'Previous Full Week',
    'Previous Full Month': 'Previous Full Month',
    'ReportsSummarizedReport': 'Summarized Report',
    'ReportsStart': 'Start Time: ',
    'ReportsEnd': 'End Time: ',
    'ReportsPrintDate': 'Print Date: ',
    'ReportsPrintTime': 'Print Time: ',
    'ReportsPage': 'Page ',
    'ReportsOf': 'of ',
    'ReportsStop': 'Stop Time: ',
    'ReportsLongest': 'Longest',
    'ReportsTimes': 'Times',
    'ReportsGoalsStatsFor': 'GOALS STATISTICS FOR',
    'ReportsAveragePerformancePerEvent': 'AVERAGE PERFORMANCE PER EVENT',
    'ReportsGoalA': 'Goal A',
    'ReportsGoalB': 'Goal B',
    'ReportsGoalC': 'Goal C',
    'ReportsGoalD': 'Goal D',
    'ReportsDerivedPerformancetoGoal': ' Derived performance to goal (Lane Queue goal = Lane Total goal - Menu goal - Service goal)',
    'ReportsLane': 'Lane',
    'ReportsAverageCarsInLane': 'Average Cars in Lane',
    'ReportsTotalPullouts': 'Total Pullouts',
    'ReportsTotalPullins': 'Total Pullins',
    'ReportsDeleteOverMax': 'Delete Over Maximum',
    'ReportsPowerFails': 'Power Fails',
    'ReportsSystemResets': 'System Resets',
    'ReportsVBDResets': 'VBD Resets',
    'ReportsLoadingPleaseWait': 'Please wait while your report is being generated...',
    'ReportsPleaseNote': 'Please Note: This report may take a while to load depending on the amount of data being requested.',
    'Default Dashboard View': 'Default Dashboard View',
    'Display Settings': 'Display Settings',
    'Select a default view for your': 'Select a default view for your single-store and multi-store dashboards. By selecting either daypart, day, week, month or custom',
    'This will be the view you': 'This will be the view you first see when clicking on the ZOOM Dashboard link from the navigation bar.',
    'You must first configure a customized': 'You must first configure a customized dashboard before selecting the custom option as your default view.',
    'Select a custom goal color': 'Select a custom goal color for your master A, B and over B goals by using the color pickers',
    'These colors will allow you to easily': 'These colors will allow you to easily identify the performance metrics for each of your stores.',
    'You can also manually enter the hexadecimal': 'You can also manually enter the hexadecimal value of the color if you prefer.',
    'Select the default time format': 'Select the default time format',
    'that will be shown on your': 'that will be shown on your dashboards and reports.',
    'Time format may be shown in minutes:seconds': 'Time format may be shown in minutes:seconds or in seconds.',
    'For dashboards and reports': 'For dashboards and reports, you can choose to either include pull-in',
    'data or exclude it': 'data or exclude it.',
    'A pull-in is a vehicle that entered': 'A pull-in is a vehicle that entered the drive-thru lane after the first ON detection point, and exited through the last ON detection point.',
    'Store abbrev': 'Store',
    'Display Settings changes successful': 'Display Settings changes successful',
    'ReportsAll': 'All',
    'ReportsAverageTime': 'AVERAGE TIME',
    'ReportsWeightedAverage': '(W-Avg)',
    'ReportsShow': 'Show',
    'ReportsTotalCars': 'Total Cars',
    'Total Cars': 'Total Cars',
    'ReportsPages': 'Pages',
    'ReportsOpen': 'OPEN',
    'ReportsClose': 'CLOSE',
    'ReportsOr': 'OR',
    'Greet': 'Greet',
    'Greet1': 'Greet 1',
    'Greet2': 'Greet 2',
    'Greet 1': 'Greet 1',
    'Greet 2': 'Greet 2',
    'Order': 'Order',
    'Order Point1': 'Order Point1',
    'Order Point2': 'Order Point2',
    'Order1': 'Order1',
    'Order2': 'Order2',
    'MenuBoard': 'Menu',
    'Cashier': 'Cashier',
    'Pickup': 'Pickup',
    'LaneQueue': 'Lane Queue',
    'Lane Queue': 'Lane Queue',
    'Lane Queue 2': 'Lane Queue 2',
    'Metrics': 'Metrics:',
    'LaneTotal': 'Lane Total',
    'LaneTotal2': 'Lane Total 2',
    'Lane Total 2': 'Lane Total 2',
    'dashboardonly': '(Dashboard Only)',
    'MenuBoard1': 'Menu Board1',
    'MenuBoard2': 'Menu Board2',
    'Menu Board1': 'Menu Board1',
    'Menu Board2': 'Menu Board2',
    'OPEN': 'OPEN',
    'CLOSE': 'CLOSE',
    'CUSTOM': 'CUSTOM',
    'MONTH': 'MONTH',
    'WEEK': 'WEEK',
    'DAY': 'DAY',
    'DAYPART': 'DAYPART',
    'HOUR': 'HOUR',
    'permissions': 'Permissions',
    'Current:': 'Current:',
    'bottom3stores': 'Bottom 3 Stores',
    'yourranking': 'Your Ranking',
    'ReportsEmailCSVVersion': 'Email CSV version',
    'ReportsRawDataReport': 'Raw Car Data Report',
    'ReportsNoRecordsFound': 'No records found',
    'NoRecordsFound': 'No records found',
    'ReportsDepartureTime': 'Departure Time',
    'ReportsEventName': 'Event Name',
    'ReportsCarsinQueue': 'Cars In Queue',
    'Car_Departure': 'Car_Departure',
    'Description': 'Description',
    'HelpFrequentlyAskedQs': 'Frequently Asked Questions',
    'HelpOperatingInstructions': 'HME CLOUD Operating Instructions',
    'HelpNewFeatures': 'New Features',
    'HelpNewDashboardOrReport': 'What if I want to create a custom report or dashboard?',
    'HelpContactYourSalesRep': 'Contact your sales representative or dealer to discuss your options.',
    'HelpHowChangePassword': 'How do I change my password?',
    'HelpSignInClickOnMyAccount': 'Sign in and click on My Account.',
    'HelpWhatIfForgotPass': 'What if I forgot my password?',
    'HelpGoHomeClickForgotPass': "Go to the HME CLOUD home page and click on 'I forgot my password'.",
    'HelpHowSetDayparts': "How do I set my dayparts for HME CLOUD's Dashboard and Reports to show the information I want to see?",
    'HelpAllSettingsInDashboard': 'All of your ZOOM timer settings are automatically uploaded and displayed in your HME CLOUD Dashboard and Reports.',
    'HelpWhatAreRoles': 'As a Company Administrator adding more users to my account, what is the difference between adding a 1) Company Administrator; 2) District Manager; 3) Regional Manager;  4) Store Manager?',
    'HelpCompanyAdminPowers': 'A Company Administrator can create other users and can access features such as Reboot System, and Force Reconnect.',
    'HelpCompanyManagerPowers': 'District Managers, Regional Managers, and Store Managers cannot access Reboot System, and Force Reconnect or create additional users.',
    'HelpDeterminePermissionLevel': 'How do I determine what is my permission level?',
    'HelpPermissionLevelIsOnMyAccount': 'Click on My Account and view your permission level under User Information.',
    'HelpUpdateEmployeeList': 'What do I do if an employee leaves and I want to update my User list?',
    'HelpAccessUserList': "Access the 'Users' page and click on the View/Edit User link to update the username (email address) and store access checklist.",
    'HelpAccessZoomSettingsRemotely': 'How can I change my ZOOM settings remotely?',
    'HelpAccessZoomSettingsInstructions': 'Click on Stores and click on Online in the right-hand column.  It may take several seconds for the ZOOM web portal to appear.  Click on the gear icon at the top left corner to access ZOOM settings.',
    'HelpSubscription': 'Subscription',
    'HelpDoSubscriptionsRenew': 'Does my subscription auto-renew each year?',
    'HelpYesSubscriptionsRenew': 'Your subscription will renew for all your stores each year on the anniversary of your initial subscription.',
    'HelpWhenSubscriptionExpires': 'How do I know when my subscription expires?',
    'HelpContactTechSupport': 'Contact HME Tech Support at 800-848-4468 options 1, 2, 3 and they can let you know when you current subscription expires and next year of service begins.',
    'HelpCancelMySubscription': 'How do I cancel my subscription?',
    'HelpCancelationInstructions': 'If you wish to cancel your subscription, please contact your HME sales representative or dealer.',
    'HelpAddingStoresFullPrice': 'If I add a store to my subscription, am I charged for a full year?',
    'HelpAddingStoresDiscountedPrice': 'You will be charged for the number of months left before your annual subscription renews.',
    'HelpTroubleshooting': 'Troubleshooting',
    'HelpDashboardNoContent': 'When I click on Dashboard or Reports, I do not see any content.',
    'HelpYouMayNeedPremium': 'You may need a premium subscription. To subscribe to HME CLOUD and get full access, please contact your HME sales representative.',
    'HelpNewZoomNotShowing': 'I installed a new ZOOM timer, but it is not showing up in my HME CLOUD account as one of my stores.',
    'HelpConfirmZoomConfigured': 'There are few key configurations that enable the ZOOM timer to register with the HME CLOUD and your account:',
    'HelpConfirmFirmwareVersion': 'Verify your firmware version is 2.0 or later.',
    'HelpConfirmAdminStatus': 'If you do not have a Company Administrator account (e.g., you are a store manager), your Company Administrator must assign stores to you, and then you will see the stores in your account.',
    'HelpConfirmTimerOptIn': 'The timer must be configured for opt-in for HME CLOUD service.  Your Installer or HME support representative can assist with verifying the configuration.',
    'HelpVerifyPortsOpen': 'Your network must have outbound ports 18000 and 19000 open.',
    'HelpVerifyActiveAccount': 'You must have a user account set up and the email address configured on the ZOOM timer must match the email address (user name) of the HME CLOUD account.',
    'HelpHowToGetHelp': 'How do I contact HME when I need technical assistance?',
    'HelpContactUs': 'Contact HME Tech Support at 800-848-4468 options 1, 2, 3',
    'HelpPossibleInnaccurateData': 'What do I do if I think my dashboard is not displaying accurate information?',
    'HelpHandlingMissingData': "Check to ensure you're looking at the correct store.  If the detection points or times look inaccurate or are missing information, report this issue to HME Tech Support to troubleshoot.",
    'HelpUnableToConnect': "When I try to make a remote connection to my system I get an 'unable to connect' message. ",
    'HelpConnectingNeedsScripts': 'Certain browsers require the user to accept a script loading message before they will allow the page to load. Reload the page and attempt to make the remote connection. For Firefox and Chrome you will see a Shield appear in the address bar. Click the Shield and allow the script to run. For Internet Explorer, a pop up message will appear at the bottom of the page for a few seconds, click this message to accept the script. Now the remote connection can be made. Most browsers will remember your choice and you should not have to follow this procedure again.',
    'HelpSystemStatusUnavailable': 'When I look in the Stores list I notice some stores show a System Status of Not Available. What does that mean?',
    'HelpStoreIsUnregistered': 'It means your store is no longer registered with the HME CLOUD. If you wish, you can delete this store entry by clicking View/Edit Details for that store and click the Delete Store Link.  If you want to re-register the store with HME CLOUD, please contact HME Technical Support at 800-848-4468 options 1, 2, 3.',
    'HelpContactByEmail': 'Contact HME CLOUD support by',
    'HelpIfAddStoreSub': 'If I add a store to my subscription, am I charged for a full year?',
    'AttemptingConnection': 'Attempting Connection',
    'RebootStarted': 'Reboot Started',
    'UpgradeStarted': 'Upgrade Started',
    'settingsDevicesFirmwareVersion': 'Firmware Version',
    'settingsDevicesSettingVersion': 'Settings Version',
    'settingsDevicesRegisteredToStoreInfo': 'Registered to Store Info',
    'settingsDevicesLaneConfiguration': 'Lane Configuration',
    'settingsDevicesFirstActivity': 'First Activity',
    'settingsDevicesLastActivity': 'Last Activity',
    'settingsDevicesNumberOfRecords': 'Number of Records',
    'settingsDevicesUpgrade': 'Upgrade',
    'settingsDevicesReboot': 'Reboot',
    'settingsDevicesForce': 'Force',
    'settingsDevicesReconnect': 'Reconnect',
    'SingleLane': 'Single Lane',
    'DualLane': 'Dual Lane',
    'YLane': 'Y Lane',
    'Single Lane': 'Single Lane',
    'Dual Lane': 'Dual Lane',
    'Y Lane': 'Y Lane',
    'Please select a Time Format option': 'Please select a Time Format option.',
    'Please select a Pull-Ins option': 'Please select a Pull-Ins option',
    'Please select Primary Goal Colors': 'Please select Primary Goal Colors.',
    'There has been an error processing your request': 'There has been an error processing your request, please try again later.',
    'You are about to be signed out': 'You are about to be signed out due to inactivity.',
    'YouAreAboutToBeSignedOut': 'You are about to be signed out due to inactivity.',
    'YouAreCurrentlyViewing': 'You are currently viewing the site as',
    'ContinueViewingAs': 'Continue Viewing as',
    'Car_Pull_In': 'Car_Pull_In',
    'Car_Pull_Out': 'Car_Pull_Out',
    'Stay Logged In': 'Stay Logged In',
    'StayLoggedIn': 'Stay Logged In',
    'Auto Logout': 'Auto Logout',
    'AutoLogout': 'Auto Logout',
    'Show:': 'Show:',
    'longesttimesandsystemstatistics': 'Longest Times, System Statistics',
    'Please select the column of data': 'Please select the column of data you would like to',
    'rank your stores by': 'rank your stores by',
    'minigoal': 'Goal',
    'viewFranchise': 'View Franchises',
    'leaderboardgroups': 'Leaderboard Groups',
    'leaderboardgroupManage': 'Leaderboard Group Management',
    'franchiseHelp': 'Select to include any shared Franchise data',
    'leaderboardgroupsdetails': 'Leaderboard Group Details',
    'addagroup': 'Add New Group',
    'manageleaderboardgroups': 'Manage Leaderboard Groups',
    'managereportgroups': 'Manage Hierarchy',
    'groupname': 'Group Name',
    'createdBy': 'Created By',
    'createdDate': 'Date Created',
    'deletegroup': 'Delete Role',
    'settingsStoresGroup': 'Group',
    'storesingroup': 'Stores in Group',
    'groupdescription': 'Group Description',
    'StoreSettingsLeaderboardGroup': 'Leaderboard Groups',
    'StoreSettingsReportGroup': 'Report Group',
    'availablestores': 'Available Stores',
    'youdonthavepermission': 'You do not have permission to use this feature',
    'noStores': 'To use this feature, you must first register a Zoom with HME CLOUD.',
    'GroupNameTaken': 'A Leaderboard by the same name already exists. Please create a unique Leaderboard name.',
    'Active groups require': 'Active groups require at least 1 store to be chosen.',
    'Status is required': 'Status is required.',
    'Group name may not be blank': 'Group name may not be blank.',
    'Last Updated is empty': 'Group is not valid: Last Updated is empty.',
    'Company not found': 'Group is not valid: Company not found.',
    'Store list mismatch': 'Group is not valid: Store list mismatch.',
    'Update failed': 'Group is not valid: Update failed.',
    'Company not found in Azure': 'Group is not valid: Company not found in Azure.',
    'Create Group failed': 'Update/Create Group failed.',
    'Store Group failed': 'Update Store Group failed.',
    'Group is not valid': 'Group is not valid.',
    'Inactive Group': 'Inactive Group',
    'All stores will be removed from this group': 'All stores will be removed from this group',
    'OK': 'OK',
    'StoreNameColumn': 'Store Name Column',
    'AddNewGroup': 'Add New Group',
    'ReportingGroupManagement': 'Group Management',
    'ReportingGroupDetails': 'Group Details',
    'GroupName': 'Group Name',
    'GroupDescription': 'Group Description',
    'AvailableGroupsStores': 'Available Groups/Stores',
    'GroupsStoresinGroup': 'Groups/Stores in Group',
    'AccountInformation': 'Account Information',
    'delete': 'Delete',
    'navbarStores': 'Stores',
    'navbarSystems': 'Systems',
    'navbarUsers': 'Users',
    'navbarAccounts': 'Accounts',
    'navbarDistributers': 'Distributors',
    'navbarAudioManager': 'Audio Manager',
    'navbarOptionSettings': 'Display Settings',
    'navbarOptionLeaderboard': 'Customize Leaderboard',
    'navbarOptionHelp': 'Help',
    'subNavbarStores': 'Stores',
    'subNavbarUsers': 'Users',
    'subNavbarRoles': 'Roles',
    'subNavbarDashboard': 'Dashboard',
    'subNavbarReports': 'Reports',
    'subNavbarDeviceSettingsHistory': 'Device Settings History',
    'Groups': 'Groups',
    // added
    'requiredAccountId': 'accountId number is  required',
    'notRecordsFound': 'No Records found',
    'requiredCreatedBy': 'createdBy number is  required',
    'saveTempplateSuccess': 'Template has been saved successfully',
    'saveTemplateFailure': 'Failed to Save template',
    'invalidTemplateName': 'Invalid template Name',
    'deletedTemplate': 'Saved Template has been deleted successfully',
    'InvalidStoreId': 'Please select a Store',
    'dateCannotbeEmpty': 'Please select a date',
    'dateRangeInvalid': 'Date range invalid. For Raw Data Reports select a single day.',
    'invalidReportType': 'Invalid Report Type param',
    'invalidEmail': 'Invalid Invalid Email Id',
    'invalidRawCarStoreLength': 'Invalid selection. Please select no more than 1 store for a Raw Data Report',
    'advancedDateRangeInvalid': 'Date range invalid. For Advanced Options Reports select any 3 month period.',
    'dayPartInvalidDateRange': 'Date range invalid. For Daypart Reports select any 2 week period.',
    'weekInvalidDateRange': 'Date range invalid. For Week Reports select any 2 month period.',
    'dayInvalidDateRange': 'Date range invalid. For Day Reports select any 1 month period.',
    'fromDateGreaterThanToDate': 'Date range invalid. Starting date may not be beyond ending date.',
    'advancedDateRangeDayPartInvalid': 'Date range invalid. For Advanced Options Reports select any 3 weeks period.',
    'advancedDateRangeWeekInvalid': 'Date range invalid. For Advanced Options Reports select any 2 month period.',
    'storeSelectionInvalid': 'Store selection invalid. You may select up to 1000 stores from the list below.',
    'advancedDayInvalidDateRange': 'Date range invalid. For Advanced Options Reports select any 1 month period.',
    'groupNameEmpty': 'Group name can not be empty',
    'groupSuccess': 'Group has been created successfully',
    'groupIdInvalid': 'Invalid groupId',
    'invalidInput': 'Invalid input details has provided',
    'groupAlreadyExist': 'Group already exist in the user account',
    'groupUpdatesSuccess': 'Group has been updated successfully',
    'noRecordsFoundForDelete': 'No records found for deleting',
    'recordsDeleted': 'Records deleted Successfully',
    'recordDeleted': 'Record deleted Successfully',
    'noDataForGivenId': 'No data found for the given Id',
    'invalidRequestBody': 'Invalid request body',
    'groupCreationFailed': 'Group creation failed',
    'noDataForGivenName': 'No data found for the given name',
    'groupUpdationFailed': 'Group updation failed',
    'invalidTemplateId': 'Invalid template Id',
    'createSuccess': 'Report Template create successfully',
    'createFailure': 'Unable to Create Report',
    'deleteSuccess': 'Report Template Deleted successfully',
    'deteleFailure': 'Unable to Delete Report',

    'firstNameEmpty': 'User firstName can not be empty',
    'invalidUserUUID': 'Invalid User id',
    'usercreateSuccess': 'Record Saved',
    'userAlreadyExist': 'User already exist',
    'usercreateFailure': 'User creation failed',
    'userupdatedSuccess': 'User details updated successfully',
    'userupdateFailure': 'User details updation failed',
    'userdeleteSuccess': 'User deleted successfully',
    'userDeleteFailed': 'User deletion failed',
    'rolecreateSuccess': 'Record Saved',
    'roleAlreadyExist': 'Role already exists',
    'rolecreateFailure': 'Role creation failed',
    'roleupdatedSuccess': 'Role details updated successfully',
    'roleupdateFailure': 'Role details updation failed',
    'roledeleteSuccess': 'Role deleted successfully',
    'roleDeleteFailed': 'Role deletion failed',
    'W-Avg': 'W-Avg',
    'Total Day': 'Total Day',
    'Total Daypart': 'Total Daypart',
    'Total Week': 'Total Week',
    'SubTotal': 'SubTotal',
    'useragreementUrl': 'HMECLOUD_Terms_and_Conditions.pdf',
    'agreementUrl': 'HMECLOUD_Terms_and_Conditions.pdf',
    'privacypolicyUrl': 'HMECLOUD_Privacy_Policy.pdf',
    'californiasupplyUrl': 'California_Transparency_Supply_Chains_Act_Disclosures.pdf',
    'cookiepolicyUrl': 'HMECLOUD_Cookie_Policy.pdf',

    'Jan': 'Jan',
    'Feb': 'Feb',
    'Mar': 'Mar',
    'Apr': 'Apr',
    'May': 'May',
    'Jun': 'Jun',
    'Jul': 'Jul',
    'Aug': 'Aug',
    'Sept': 'Sept',
    'Oct': 'Oct',
    'Nov': 'Nov',
    'Dec': 'Dec',

    'Janv': 'Jan',
    'Févr': 'Feb',
    'Mars': 'Mar',
    'Avril': 'Apr',
    'Mai': 'May',
    'Juin': 'Jun',
    'Juil': 'Jul',
    'Août': 'Aug',
    'Déc': 'Dec',

    'janv': 'jan',
    'févr': 'feb',
    'mars': 'mar',
    'avril': 'apr',
    'mai': 'may',
    'juin': 'jun',
    'juil': 'jul',
    'août': 'aug',
    'sept': 'sept',
    'oct': 'oct',
    'nov': 'nov',
    'déc': 'dec',
    'Loading...': 'Loading...',
    'Loading': 'Loading',
    'Merge': 'Merge',
    'SelectSystem': 'Select System(s)',
    'System': 'System',
    'SelectTargetStore': 'Select Target Store',
    'EnterStoreNumber': 'Enter Store Number',
    'Search': 'Search',
    'Timezone': 'Timezone',
    'TandemLinesError': 'ERROR: Tandem Lanes may not be selected in multiple store reports.',
    'TandemLanesStore': 'ERROR: Tandem Lanes may not be selected in multiple store reports.',
    'errorTimeout': 'Timeout: Request failed to complete in 15000ms',
    'genericError': 'Error occured, please contact the administrator.',
    'openTime': 'Enter Open Time',
    'closeTime': 'Enter Close Time',
    // Added -- New password and confirm password validation
    'newPasswordcontainblank': 'New password may not contain blank spaces.',
    'newPasswordinvalid': 'Invalid new password.',
    'newPasswordsize': 'New password must be between 8 and 16 characters in length.',
    'newPassworduppercase': 'New password must contain at least 1 uppercase character.',
    'newPasswordlowercase': 'New password must contain at least 1 lowercase character.',
    'newPasswordnumber': 'New password must contain at least 1 number.',
    'confirmasswordcontainblank': 'Confirm password may not contain blank spaces.',
    'confirmpasswordinvalid': 'Invalid confirm password.',
    'confirmPasswordsize': 'Confirm password must be between 8 and 16 characters in length.',
    'confirmPassworduppercase': 'Confirm password must contain at least 1 uppercase character.',
    'confirmPasswordlowercase': 'Confirm password must contain at least 1 lowercase character.',
    'confirmPasswordnumber': 'Confirm password must contain at least 1 number.',
    'confirmPasswordcontainblank': 'Confirm password may not contain blank spaces.',
    'passwordmisMatch': 'New Password and Confirmed Password mismatch.',
    'distributors': 'Distributors',
    'AddDistributor': 'Add a Distributor',
    'percent': 'Goal%',
    'storeNumber': 'Number',
    'storeRank': 'Rank',
    'storeName': 'Name',
    'login_reminder': 'Attention internal users: Please use your HME credentials to log in to the Admin site.',
    'seldistributor': '***Select Distributor***:',
    'distributorName': 'Distributor Name',
    'HelpSubscription_type': 'Subscription Type',
    'StartDate': 'Start Date',
    'EndDate': 'End Date',
    'hmeAvante':'HME Avante #:',
    'InvalidIdentificationCode':'Invalid Identification Code entered.',
    'DFASubmitVerification':'Submit Verification',
    'IdentificationCodeLabel':'Identification Code',
    'IdentificationCodeToolTip':"As an added account security measure, you'll need to enter the identification code we've just sent to your email",
    'InvalidIdentificationCodeExpired': "Identification code is expired.",
    'InvalidIdentificationCodeInvalid': "Invalid Identification Code entered.",
    'InvalidIdentificationCodeBlank': 'Identification Code may not be blank.',
    'hmedashboardheaderrealtime': 'HME CLOUD REAL TIME DASHBOARD',
    'pullintextforexclude': 'The data excludes pullins',
    'userInActive': 'User is inactive',
    'storeTZSaveSuccess':'Timezone has been saved.',
    'storeTZSaveError':'Store TZ not added.',
    'storeTZBlank':'Please select timezone.',
    'storenameblank':'Store name can not be blank.',
    'MustSelectStLeastOneSystem' : "Must select at least one system.",
    'MustSelectTargetStore':'Must select a target store.',
    'Mergeconfirmation':'Are you sure you would like to proceed ?',
    'mergeActionRemove':'This action will remove the following system(s) from the CLOUD',
    'MergeTargetStoreOffline':'The Target Store should be Offline.',
    'storestatus':'Status',
    'searchAll':'Search all',
    'SearchBrand':'Search brand',
    'SearchStore':'Search store',
    'SearchStoreName':'Search store name',
    'SearchSerial':'Search serial',
    'SearchSystemVersion':'Search system version',
    'Serial':'Serial',
    'RemoveSystem':'Remove System',
    'RemoteSystemActions':'Remote System Actions',
    'homepageMyAccountDescriptionForAdmin':'Add new accounts or Edit existing account information.',
    'homepageStoresDescriptionForAdmin':'Edit contact info for existing stores. View ZOOM settings for each store and access live dashboards.',
    'homepageUsersDescriptionForAdmin':"Edit existing users' contact info and store access.",
    'Details': 'Details',
    'StoreSettingsSerialno': 'Serial Number',
    'View': 'View',
    'RegisteredDevices': 'Registered Devices',
    'SelectTimezone' : 'Select a Timezone',
    'storemergetext':'To merge and/or remove duplicates',
    'clickhere':'click here.',
    'Master':'Master',
    'Settings':'Settings',
    'HMECLOUDOperatingInstructionsUrl':'HME_CLOUD_Operating_Instructions.pdf',
    'HMECLOUDOperatingInstructions':'HME CLOUD Operating Instructions',
    'Zoomdeviceunreachable': 'Zoom device unreachable for disconnect. Please try your request again later',
    'UnregisteredSystems':'Unregistered Systems',
    'LBGroup': 'Leaderboard Group',
    'CreateLBGroup': 'Create Leaderboard Group',
    'create': 'Create',
    'Members':'Members',
    'Showing':'Showing',
    'of':'of',
    'results':'results',
    'Show':'Show',
    'Edit':'Edit',
    'Invite':'Invite',
    'Assign':'Assign',
    'Remove':'Remove',
    'JoinDate':'Join Date',
    'MembersNumberOfStores':'Number of Stores',
    'MembersStatus':'Status',
    'MembersIsAdmin':'Is Admin?',
    'MembersOf':"Members of",
    'SendInvite':"Send Invitation",
    'toTheseStores':"to These Stores",
    'AssignedGroupOrLeaderboard':'Assigned Leaderboard',
    // 'lbSelectedWillShowInStoresSelectedAbove':'*Leaderboard selected will show in the stores selected above',
    'selectedGroupWillReplaceCurrentStoresLB':'*Selected store\'s will be added to the leaderboard',
    'noStoresFound':'No stores found.',
    'noGroupsFound':'No groups found',
    'noMembersFound':'No members found.',
    'confirmRemoval':'Confirm Removal',
    'areYouSureYouWantToRemoveThisGroupMember':'Are you sure you want to remove this group member?',
    'areYouSureYouWantToChangeMakeGroupMemberAnAdmin':'Are you sure you want to make this group member the owner?',
    'invitationMailAlreadySentToUser':'Invitation Mail Already Sent to User!',
    'pleaseSelectALeaderBoardGroup':'Please Select a LeaderBoard Group!',
    'reject':'Reject',
    'confirmInvitation':'Confirm Invitation',
    'pleaseClickBelowToAcceptInvitation':'Please click below to accept invitation!',
    'GroupName': 'Group Name',
    'InvitedBy': 'Invited By',
    'InvitedDate': 'Invited Date',
    'AcceptInvitation': 'Accept Invitation!',
    'MakeAdmin': 'Make Owner',
    'LeaderboardOwner': 'Leaderboard Owner',
    'ChooseNewAdmin':'Choose New Owner',
    'pleaseEnterValidGroupTitle' : 'Please Enter Valid Group Title!',
    'languagePreference' : 'Language Preference:',
    'youcannotdeleteadminsorsolemembers':'You cannot delete admins or sole members from groups.',
    'French': 'French',
    'English': 'English',
    'InvalidEmail' : 'Invalid Email',
    'InvalidEmailLanguage' : 'Invalid Email Language',
    'selectCriteria':'Select Criteria',
    'actions':'Actions',
    'PasswordRequirements':'Password Requirements',
    'ResetPasswordLength':'The length of the password must be at least eight (8) characters and not more than sixteen (16) characters.',
    'ResetPasswordBlank':'The password may not contain blank spaces.',
    'ResetPasswordGroup':'The password must contain at least one (1) character from each of the three (3) groups below:',
    'ResetPasswordGroupUpperCase':'English uppercase characters (A through Z)',
    'ResetPasswordGroupLowerCase':'English lowercase characters (a through z)',
    'ResetPasswordGroupNumerals':'Numerals (0 through 9)',
    'NoDeviceFound': 'No Devices Found',
    'homepageMyAccountPublic': 'My account',
    'settingsStoresNotavailable':'Not Available',
    'removeStoreConfirm':'Are you sure you would like to remove the selected store?',
    'warning':'WARNING',
    'actioncannotbeundone':'This action cannot be undone!',
    'storeRemoveSuccess':'Success! The requested store has been removed.',
    'Upgradeyouraccount': 'Upgrade your account to Premium service to get access to this feature',
    'Toupgradenow': 'To upgrade now',
    'pleasecall': 'please call',
    'DomesticSales': 'Domestic Sales',
    'Options': 'Options',
    'InternationalSales': 'International Sales',
    'for': 'for',
    'othercountries': 'other countries',
    'storeRemoveFailure':'Error! Something went wrong, please try your request again.',
    'RemoveStore':'Remove Store',
    'undergomaintenanceon':"The HME CLOUD will undergo maintenance on",
    'undergomaintenanceontemporarilyunavailable':"Website and in-store Leaderboard display will be temporarily unavailable",
    'GMT':'GMT',
    'Zoomdeviceunreachablefordisconnect': 'Zoom device unreachable for disconnect. Please try your request again later.',
    'Zoomdeviceunreachable': 'Zoom device unreachable. Please try your request again later.',
    'BadDeviceID': 'Bad Device ID. The system administrator has been notified.',
    'NoDistributorsFound': 'No Distributors Found',
    'currentlyviewingasUser':'Currently viewing as User',
    'Leaderboard':'Leaderboard',
    'AddLeaderboard':'Add Leaderboard',
    'Title':'Title',
    'AddNewLeaderboard': 'Add New Leaderboard',
    'LeaderboardOverview': 'Leaderboard Overview',
    'LeaderboardName': 'Leaderboard Name',
    'LeaderboardDescription': 'Leaderboard Description',
    'LeaderboardDetails':'Leaderboard Details',
	  'EditLeaderboardDetails':'Edit Leaderboard Details',
	  'LeaderboardContests':'Contests',
    'LeaderboardAwards':'Awards',
    'LeaderboardSmackTalk':'Smack Talk',
    'LeaderboardFeedback':'Feedback',
    'Leaderboards': 'Leaderboards',
    'DefaultGroup': 'Default Group',
    'StoresInLeaderboard':'Stores In Leaderboard:',
    'SelectStores':'Select Stores:*',
    'Submit':'Submit',
    'noLeaderboardSubscription' : 'The person that you invited to participate in your Leaderboard does not have a Leaderboard subscription.',
    'noEditLeaderboardPermission': 'The person that you invited to participate in your Leaderboard does not have the permission to receive Leaderboard invitations.',
    'inviteFailed': 'Leaderboard Invitation Failed',
    'inviteSuccess': 'Your invitation has been sent.',
    'notfound': 'The person that you invited to participate in your Leaderboard is not a valid HME CLOUD user.',
    'participatingAccounts':'Participating Accounts',
    'participatingUsers':'Participating Users',
    'LBInviteSuccess1':'Congratulations, you have accepted to join the new Leaderboard!',
    'LBInviteSuccess2':'All of your stores will be automatically moved over to the new Leaderboard',
    'LBInviteLoginNew':'Click here to log into the HME CLOUD and view your new Leaderboard:',
    'LBInviteLoginCurrent':'Click here to log into the HME CLOUD and view your current Leaderboard:',
    'LBInviteReject':'You have chosen to decline the invitation to join a new Leaderboard.',
    'LBInviteInvalidURL':'Invalid/Expired URL',
    'LastUpgrade': 'Last Upgrade',
    'currentlyviewingasUserAccountOwner': 'Currently viewing as User Account Owner',
    'settingsSent': 'Settings Sent!',
    'NoStoresFound': 'No Stores Found',
    'InternalErrorSomethingWentwrong': 'Sorry, Something went wrong',
    'InternalErrorContactAdministrator': 'Sorry, Please contact your administrator.',
    'InternalErrorTechnicalDetails': 'TECHNICAL DETAILS',
    'InternalErrorError': 'Error',
    'InternalErrorGoBackToSite': 'GO BACK',
    'MergeTargetStoreNoDeviceAssociated': 'There is no device associated to target store.',
    'sameCompanyInvite': 'Leaderboard invitation should not be sent out to a user from the same account',
    'youAreNotAllowedToMakeThisUserAnOwner': 'You are not allowed to make this user an owner',
    'acceptedInvite': 'Accepted Invite',
    'deniedInvite': 'Denied Invite',
    'companyExistsInLB':'The invited company already exists in the Leaderboard.',
    'companyDeniedInLB':'The invited company has already denied an invitation.',
    'companyPendingInLB':'The invited company has already been sent an invitation.',
    'selectStoresMsg':'Please select Stores to add to this Leaderboard.',
    'NoParticipantStores': 'No Stores',
    'declineInvitation': 'Are you sure you would like to decline the invitation?',
    'selectNoStores': 'Are you sure you would like to select no stores at this time?',
    'storeSelection': 'Store Selection',
    'declineInvitationHeader': 'Decline Invitation',
    'inviteHello' : 'Hello,',
    'inviteMessage1' : ' has invited you to participate in a shared Leaderboard store ranking!',
    'inviteConsent' : 'Consent: ',
    'inviteMessage2' : 'Please note that if you accept this invitation, you are consenting to having your stores Leaderboard ranking information shared with ',
    'inviteMessage3' : ' and the others stores in the same Leaderboard.',
    'inviteMessage4' : 'Clicking “Yes, I accept and will select my stores” button below will direct you to select your stores to add to the inviter’s Leaderboard.',
    'inviteMessage5' : 'Clicking “No, I decline the invitation” will decline the invitation. ',
    'inviteAcceptBtn1' : 'Yes, I accept and will',
    'inviteAcceptBtn2' : 'select my stores',
    'inviteRejectBtn1' : 'No, I decline the',
    'inviteRejectBtn2' : ' invitation',
    'inviteOptout' : 'Opt Out: ',
    'inviteMessage6' : 'If at any time, you wish to return your stores to your own account Leaderboard, you may log into the HME CLOUD and remove them from the Leaderboard Overview',
    'Pending': 'Pending',
    'Denied': 'Denied',
    'Accepted': 'Accepted',
    'LeaderboardAd1' : 'This area is for the administration of the HME’s Drive-thru Leaderboard, HME’s store ranking dashboard that creates friendly competition between stores to motivate crews and increase performance!',
    'LeaderboardAd2' : 'You are not subscribed to this service. To subscribe, please contact your HME Account Representative or call: U.S. Sales: ',
    'LeaderboardAd3' : ' or International Sales: ',
    'LeaderboardAdPhone1' : '800.848.4468',
    'LeaderboardAdPhone2' : '+1 858.535.6000',
    'LeaderboardNoEditPerm' : 'The account administrator in your organization has not provided you permission to use this feature. If you feel that you should have permission, please contact your account administrator to provide it for you.',
    'ParticipatingStores':'Participating Stores',
    'ViewMyStoresOnly':'View my stores only',
    'Default':'  (Default)',
    'multipleEmailsErrorMessage': 'You may not enter more than one email address. Please revise the email address entered.',
    'enterSingleEmailMessage': 'Enter a single email address for the account you will invite.'


  },

  // French
  {
    'username': 'Nom d\u2019utilisateur',
    'password': 'Mot de passe',
    'submitBtn': 'Connexion',
    'forgotpass': 'J\u2019ai oubli\u00E9 mon mot de passe',
    'cookiepolicy': 'Politique concernant les t\u00E9moins',
    'californiasupply': "Loi sur la cha\u00EEne d'approvisionnement de la Californie",
    'privacypolicy': 'Politique sur la protection des renseignements personnels',
    'useragreement': 'Contrat d\u2019utilisation',
    'loginattemptsnumber': 'Tentatives de connexion ',
    'loginattemptsexceeded': 'Vous avez d\u00E9pass\u00E9 le nombre de tentatives de connexions permis. Veuillez r\u00E9essayer plus tard.',
    'emailaddress': 'Adresse de courriel\u00A0:',
    'userEmail': 'adresse email de l\'utilisateur',
    'resetpassBtn': 'R\u00E9initialiser le mot de passe',
    'internalservererror': 'Erreur de serveur interne',
    'internalservererrorP1': 'Il s\u2019est produit une erreur interne au moment de traiter votre demande.',
    'internalservererrorP2': "L'administrateur du syst\u00E8me a \u00E9t\u00E9 inform\u00E9 et il s\u2019efforce de r\u00E9gler le probl\u00E8me le plus rapidement possible.",
    'internalservererrorP3': 'Si vous continuez d\u2019\u00E9prouver des difficult\u00E9s \u00E0 charger cette page, veuillez vous adresser directement au service d\u2019assistance.',
    'usernameinvalid': 'Nom d\u2019utilisateur non valide. Veuillez essayer de nouveau',
    'invalidcredentials': 'Authentifiants non valides. Veuillez essayer de nouveau',
    'passwordblank': 'Le champ du mot de passe ne peut pas \u00EAtre vide. Veuillez essayer de nouveau',
    'loginattemptinvalid': 'Tentative de connexion non valide. L\u2019administrateur du syst\u00E8me a \u00E9t\u00E9 inform\u00E9.',
    'loginfail': '\u00C9chec de connexion. Le nom d\u2019utilisateur ou le mot de passe que vous avez entr\u00E9 est inconnu du syst\u00E8me. Si le probl\u00E8me persiste, veuillez communiquer avec votre administrateur de syst\u00E8me.',
    'emailblank': 'Le champ d\u2019adresse courriel ne peut pas \u00EAtre vide.',
    'emailinvalid': 'L\u2019adresse courriel n\u2019est pas valide. Veuillez essayer de nouveau',
    'emailconfirm': 'Veuillez confirmer votre adresse de courriel.',
    'passwordsize': 'Le mot de passe doit avoir une longueur de 8 \u00E0 16 caract\u00E8res.',
    'passworduppercase': 'Le mot de passe doit contenir au moins une lettre majuscule.',
    'passwordlowercase': 'Le mot de passe doit contenir au moins une lettre minuscule.',
    'passwordnumber': 'Le mot de passe doit contenir au moins 1 chiffre.',
    'passwordcontainblank': 'Le mot de passe ne peut pas contenir d\u2019espace.',
    'blankfirst': 'Veuillez entrer votre pr\u00E9nom.',
    'blanklast': 'Veuillez entrer votre nom de famille.',
    'blankcompany': 'Veuillez entrer le nom de votre entreprise.',
    'blankstate': 'Veuillez entrer votre \u00E9tat ou votre province.',
    'blankavante': 'Veuillez entrer votre num\u00E9ro Avante.',
    'blankterms': 'Veuillez accepter les conditions avant de continuer.',
    'blankshareddata': 'Veuillez accepter ou refuser l\u2019entente de partage des donn\u00E9es.',
    'emailnomatch': 'Les adresse courriel entr\u00E9es ne sont pas identiques.',
    'passwordnomatch': 'Les mots de passe entr\u00E9e ne sont pas identiques.',
    'emailused': 'L\u2019adresse courriel est d\u00E9j\u00E0 utilis\u00E9e.',
    'usersignupsuccess': 'Inscription r\u00E9ussie',
    'usersignupactivate': 'Vous avez presque termin\u00E9. Veuillez v\u00E9rifier votre bo\u00EEte de courriel pour activer votre nouveau compte.',
    'loginsexceed': 'Nombre de tentatives de connexion permises d\u00E9pass\u00E9',
    'confirmemailaddress': 'Confirmation de l\u2019adresse courriel\u00A0:',
    'passwordcolon': 'Mot de passe\u00A0:',
    'confirmpasswordcolon': 'Confirmation du mot de passe\u00A0:',
    'firstname': 'Pr\u00E9nom\u00A0',
    'lastname': 'Nom de famille\u00A0',
    'avantenum': 'Num\u00E9ro Avante\u00A0',
    'companyname': 'Nom de l\u2019entreprise\u00A0',
    'companystate': '\u00C9tat/province de l\u2019entreprise\u00A0:',
    'emailaddresscolon': 'Adresse de courriel\u00A0:',
    'confirmemailaddresscolon': 'Confirmation de l\u2019adresse courriel\u00A0:',
    'shareddata': 'Donn\u00E9es partag\u00E9es ',
    'agreement': 'Contrat',
    'accept': 'Accepter',
    'decline': 'Refuser',
    'usernotfound': 'Le dossier d\u2019utilisateur que vous tentez d\u2019activer est introuvable.',
    'tologintoyouacct': 'pour vous connecter \u00E0 votre compte.',
    'useracctactivated': 'Compte utilisateur activ\u00E9',
    'passwordlinkinvalid': 'Lien de mot de passe non valide. Veuillez soumettre votre requ\u00EAte de nouveau.',
    'passwordexpire': 'Lien de mot de passe expir\u00E9. Veuillez soumettre votre requ\u00EAte de nouveau.',
    'passwordresetconfirm': 'Confirmation de la r\u00E9initialisation du mot de passe',
    'please': 'Veuillez',
    'login': 'vous connecter',
    'toyouraccount': '\u00E0 votre compte.',
    'newpassword': 'Nouveau mot de passe\u00A0:',
    'passwordrequirements': 'Exigences du mot de passe',
    'lengthofpasswordLi': 'Le mot de passe doit avoir une longueur d\u2019au moins huit (8) caract\u00E8res et d\u2019au plus seize (16) caract\u00E8res.',
    'passwordblankLi': 'Le mot de passe ne peut pas contenir d\u2019espaces.',
    'passwordgroupsLi': 'Le mot de passe doit contenir au moins un caract\u00E8re de chacun des trois (3) groupes suivants\u00A0:',
    'passwordgroupupperLi': 'Lettre majuscule de l\u2019alphabet anglais (A \u00E0 Z)',
    'passwordgrouplowerLi': 'Lettre minuscule de l\u2019alphabet anglais (A \u00E0 Z)',
    'passwordgroupnumberLi': 'Chiffre (0 \u00E0 9)',
    'passResetSent': 'Demande de r\u00E9initialisation du mot de passe envoy\u00E9e',
    'pleasecheckemailresetpass': 'Veuillez v\u00E9rifier votre bo\u00EEte de courriel pour r\u00E9initialiser votre mot de passe.',
    'passresetchangeEmail': 'Nous avons re\u00E7u une demande de r\u00E9initialisation de mot de passe pour votre compte HME CLOUD\u00A0: Si vous avez fait cette demande, veuillez cliquer sur le lien ci-dessous ou le copier et coller dans la barre d\u2019adresse de votre navigateur Web. http://#APPLICATION.rootURL#/?pg=ManageAccount&st=rl&ruid=#Reset_UID# Ce lien est valide pour les deux prochaines heure ou jusqu\u2019\u00E0 ce que vous r\u00E9initialisez votre mot de passe. Si vous n\u2019avez pas demand\u00E9 de r\u00E9initialisation de votre mot de passe, veuillez ignorer ce courriel. Un autre utilisateur peut avoir entr\u00E9 votre nom d\u2019utilisateur par erreur. Aucun changement ne sera apport\u00E9 \u00E0 votre compte. L\u2019\u00E9quipe HME CLOUD',
    'homepageNewFeatures': 'HME CLOUD a \u00E9t\u00E9 mis \u00E0 jour et contient de nouvelles fonctions! ',
    'homepageNewFeaturesLink': 'Pour en savoir plus',
    'homepageMaintenanceMessage': 'HME CLOUD fera l\u2019objet de t\u00E2ches d\u2019entretien le',
    'homepageWebsiteAndLeaderboardMaintenance': 'L\u2019affichage du site Web et du classement en restaurant seront temporairement indisponibles',
    'homepageLeaderboardMaintenance': 'L\u2019affichage du classement en restaurant sera temporairement indisponible',
    'homepageWelcomeMessage': 'Bienvenue \u00E0 HME CLOUD ',
    'homepageStores': 'Restaurants',
    'homepageStoresDescription': 'Afficher les r\u00E9glages ZOOM pour chaque restaurant et acc\u00E9der au tableau de bord en direct.',
    'homepageUsers': 'Utilisateurs',
    'homepageUsersDescription': 'Ajouter des utilisateurs ou modifier l\u2019information de contact et l\u2019acc\u00E8s au restaurant d\u2019utilisateurs existants.',
    'homepageMyAccount': 'Mon compte',
    'homepageMyAccountDescription': 'Changer l\u2019information de contact de votre compte et changer votre nom d\u2019utilisateur et votre mot de passe.',
    'trainingBannerLearnMore': 'Portail de formation de HME',
    'trainingBannerDescription': 'Vous y trouverez des vid\u00E9os, des documents de soutien et d\'autres guides de formation.',
    'trainingBannerPortalLink': 'Rendez-vous au portail de format de HME >',
    'headerLoggedInAs': 'Connect\u00E9 en tant que ',
    'headerSignOut': 'Déconnexion',
    'navbarWelcome': 'Bienvenue',
    'navbarDashboard': 'Tableau de bord',
    'navbarReports': 'Rapports',
    'navbarMyAccount': 'Mon compte',
    'navbarSettings': 'Param\u00E8tres',
    'navbarAudioManager': 'Gestionnaire audio',
    'navbarOptionHelp': 'Aide',
    'pleasecheckemailreport': 'Veuillez v\u00E9rifier votre bo\u00EEte \u00E0 courriels. Votre rapport a \u00E9t\u00E9 envoy\u00E9 \u00E0 ',
    'summaryReport': 'R\u00E9capitulatifs',
    'brand': 'Marque\u00A0',
    'store': 'Restaurant',
    'warningselect250stores': 'Vous pouvez choisir jusqu\u2019\u00E0 250\u00A0restaurants.',
    'warningbigoperation': 'Avertissement : Les rapports contenant 100 restaurants ou plus prennent un certain temps � g�n�rer.',
    'warning100Plus': 'Attention: un rapport de plus de 100 restaurants générera un email avec le fichier CSV.',
    'warningselect100stores': 'Vous ne pouvez pas d�passer la plage de dates par d�faut dans le cas des rapports incluant plus de 100 restaurants',
    'timemeasure': 'Mesure de temps',
    'warningselect1stores': 'Vous pouvez choisir un seul restaurant pour le rapport de donn\u00E9es brutes.',
    'from': 'De',
    'to': 'A',
    'advancedoptions': 'Options avanc\u00E9es',
    'open': 'Ouvert',
    'close': 'Ferm\u00E9',
    'OPEN-CLOSE': 'OUVRIR - FERMER',
    'type': 'Type',
    'timeslice': 'Intervalle de temps',
    'cumulative': 'Cumulatif',
    'reportsadvancedreport': '*Les rapports incluant des options avanc\u00E9es sont g\u00E9n\u00E9r\u00E9s au format .CSV et envoy\u00E9s par courriel.',
    'include': 'Inclure',
    'exclude': 'Exclure',
    'longesttimes': 'Temps les plus longs',
    'systemstats': 'Statistiques',
    'format': 'Format',
    'secondswformat': 'Secondes (sec)',
    'minuteswformat': 'Minutes (min:sec)',
    'secondsShort': '(sec)',
    'minutesShort': '(min:sec)',
    'savedreporttemplates': 'Mod\u00E8les de rapport enregistr\u00E9s',
    'generatereport': 'G\u00E9n\u00E9rer rapport',
    'criteria': 'Crit\u00E8res',
    'stores': 'Restaurants',
    'saveastemplate': 'Enregistrer comme mod\u00E8le',
    'namethistemplate': '(Nommez ce mod\u00E8le)',
    'hmeclouddashbord': 'TABLEAU DE BORD HME CLOUD',
    'rankingaccurate': 'Classement en date du',
    'goal': 'Objectif',
    'current': 'actuel',
    'previous': 'pr\u00E9c\u00E9dent',
    'full': 'Complet',
    'rank': 'Rang',
    'Number': 'Nombre',
    'offline': 'hors ligne',
    'Unavailable': 'Non disponible',
    'cars': 'Voitures',
    'avg': 'Moy',
    'pullins': 'stationnements',
    'includes': 'incluant',
    'excludes': 'excluant',
    'thedata': 'Les donn\u00E9es',
    'customizedashboard': 'Personnaliser le tableau de bord',
    'enableautorefresh': 'Activer l\u2019actualisation automatique',
    'disableautorefresh': 'D\u00E9sactiver l\u2019actualisation automatique',
    'Custom': 'Personnalis\u00E9',
    'custom': 'Personnalis\u00E9',
    'month': 'Mois',
    'Month': 'Mois',
    'week': 'Semaine',
    'Week': 'Semaine',
    'day': 'Jour',
    'Day': 'Jour',
    'daypart': 'Partie du jour',
    'hour': 'Heure',
    'Hour': 'Heure',
    'rollinghour': 'Heure cons\u00E9cutive',
    'dashboardbeinggenerated': 'Votre tableau de bord est g\u00E9n\u00E9r\u00E9, veuillez patienter...',
    'dashboardtakeawhile': 'Veuillez noter\u00A0: Selon la quantit\u00E9 de donn\u00E9es demand\u00E9es, le chargement du tableau de bord peut prendre un certain temps.',
    'rawdatareport': 'Rapport de donn\u00E9es brutes',
    'none': 'Aucun',
    'accountinfo': 'Information sur le compte',
    'recordsaved': 'S\u00E9lection enregistr\u00E9e.',
    'userinfo': 'Information sur l\u2019utilisateur',
    'user name': 'Nom de l\u2019utilisateur\u00A0:',
    'user': 'utilisateur',
    'User': "de l'utilisateur",
    'UnableToConnect': 'Connexion impossible.',
    'role': 'r\u00F4le',
    'Role': 'R\u00F4le',
    'userstoreaccess': 'Acc\u00E8s au restaurant de l\u2019utilisateur\u00A0:',
    'passchangereq': 'Changement de mot de passe n\u00E9cessaire',
    'currentpassword': 'Mot de passe actuel\u00A0:',
    'confirmnewpassword': 'Confirmer mot de passe\u00A0:',
    'jobtitle': 'Titre du poste\u00A0:',
    'officenum': 'Num\u00E9ro de bureau\u00A0:',
    'mobilephone': 'T\u00E9l\u00E9phone mobile\u00A0:',
    'fax': 'T\u00E9l\u00E9copieur\u00A0:',
    'termagreementreq': 'Disposition de l\u2019entente n\u00E9cessaires',
    'agreetohme': 'J\u2019accepte les dispositions',
    'termsofservice': 'du contrat de service de HME',
    'sharedatawithcorp': 'de partage des donn\u00E9es avec le si\u00E8ge social',
    'shared': 'Partag\u00E9es',
    'notshared': 'Non partag\u00E9es',
    'cancel': 'Annuler',
    'save': 'Enregistrer',
    'companyinfo': 'Information sur l\u2019entreprise',
    'address1': 'Adresse 1\u00A0',
    'address2': 'Adresse 2\u00A0',
    'address3': 'Adresse 3\u00A0',
    'address4': 'Adresse 4\u00A0',
    'city': 'Ville\u00A0:',
    'country': 'Pays\u00A0:',
    'state': '\u00C9tat/province\u00A0:',
    'selstate': '***Choisissez votre \u00E9tat***',
    'usterrcomm': '***Territoires des \u00C9.-U./Commonwealth***',
    'zip': 'Code Zip/postal\u00A0:',
    'region': 'R\u00E9gion\u00A0:',
    'distributor': 'Distributeur\u00A0:',
    'phone': 'T\u00E9l\u00E9phone\u00A0:',
    'users': 'Utilisateurs',
    'addauser': 'Ajouter un utilisateur',
    'viewedit': 'Afficher/modifier',
    'userdetails': 'D\u00E9tails de l\u2019utilisateur',
    'usernameemail': 'Nom d\u2019utilisateur (Adresse courriel)\u00A0:',
    'removeuser': 'Retirer utilisateur',
    'areyousureremoveuser': 'Voulez-vous vraiment retirer cet utilisateur?',
    'areyousureremovegroup': 'Voulez-vous vraiment retirer cet leaderboard?',
    'areyousuredeleterole': 'Êtes-vous sûr de vouloir supprimer ce rôle?',
    'confirmToDelete': 'Confirmer pour supprimer',
    'yes': 'Oui',
    'no': 'Non',
    'status': '\u00C9tat\u00A0:',
    'inactive': 'inactif',
    'Active': 'Actif',
    'Inactive': 'Inactif',
    'userrole': 'R\u00F4le de l\u2019utilisateur\u00A0:',
    'userAccessLevel': "Niveau d'accès utilisateur",
    'storeaccess': 'Acc\u00E8s au magasin\u00A0:',
    'selectall': 'S\u00E9lectionner tous',
    'deselectall': 'D\u00E9s\u00E9lectionner tous',
    'roles': 'R\u00F4les',
    'addarole': 'Ajouter un r\u00F4le',
    'company': 'Entreprise',
    'roledescription': 'Description du r\u00F4le',
    'optional': '(facultatif)',
    'deleterole': 'Supprimer le r\u00F4le',
    'rolename': 'Nom du r\u00F4le\u00A0:',
    'roledetails': 'D\u00E9tails du r\u00F4le',
    'leavetheopencloseboxes': 'Laissez la case Ouvert et/ou Ferm\u00E9 coch\u00E9e si vous d\u00E9sirez que les heures de d\u00E9but et de fin demeurent celles qui sont configur\u00E9es dans la minuterie ZOOM.  D\u00E9cochez ces cases si vous d\u00E9sirez pr\u00E9ciser une heure de d\u00E9but ou de fin.',
    'choosetimeslice': 'Choisissez\u00A0Intervalle de temps si vous cherchez seulement une petite fen\u00EAtre dans chaque partie de la journ\u00E9e, chaque jour ou chaque semaine.  Utilisez les commandes ci-dessus pour choisir une heure de d\u00E9but et une heure de fin.',
    'choosecumulative': 'Choisissez Cumulatif si vous voulez que le rapport inclut tout \u00E0 compter de l\u2019heure et la date de d\u00E9but \u00E0 l\u2019heure et la date de fin.',
    'chooseseconds': 'Choisissez Secondes si vous d\u00E9sirez que votre rapport soit en secondes.  Choisissez Minutes si vous voulez que le rapport soit en minutes:secondes.',
    'selectapreviousreport': 'Choisissez un mod\u00E8le de rapport pr\u00E9alablement enregistr\u00E9 pour g\u00E9n\u00E9rer un rapport courant ou choisissez de nouvelles options et enregistrez un nouveau mod\u00E8le de rapport, que vous pourrez utiliser plus tard.',
    'selectonestore': 'Choisissez un restaurant pour g\u00E9n\u00E9rer un rapport portant sur un seul restaurant.  Choisissez plusieurs restaurants pour g\u00E9n\u00E9rer un rapport comparatif.',
    'thereportwillsummarize': 'Le rapport pr\u00E9sentera un sommaire ou une moyenne des donn\u00E9es pour l\u2019intervalle de temps choisi. Par exemple, choisissez \u00AB\u00A0semaine\u00A0\u00BB si vous d\u00E9sirez que tous les jours soient combin\u00E9s en intervalles d\u2019une semaine. Dans le cas d\u2019un rapport de donn\u00E9es brutes, vous pouvez choisir un seul restaurant \u00E0 la fois.',
    'choosestartorend': 'Choisissez une date de d\u00E9but et une date de fin pour d\u00E9terminer la couverture g\u00E9n\u00E9rale du rapport. Pour un seul restaurant, vous pouvez choisir n\u2019importe quelle p\u00E9riode de deux mois. Pour plusieurs restaurants, vous pouvez choisir n\u2019importe quelle p\u00E9riode de un mois.',
    'choosestartandend': "Choisissez une date de début et de fin pour la période globale du rapport. Un maximum de 100 restaurants peuvent être sélectionnés pour une période d'un mois",
    'settingsStoresBrand': 'Marque\u00A0',
    'settingsStoresStoreName': 'Nom restaurant',
    'settingsStoresStoreNumber': 'No restaurant',
    'settingsStoresAddressLineOne': 'Adresse 1',
    'settingsStoresAddressLineTwo': 'Adresse 2',
    'settingsStoresAddressLineThree': 'Adresse 3',
    'settingsStoresAddressLineFour': 'Adresse 4',
    'settingsStoresStoreCity': 'Ville',
    'settingsStoresStoreState': '\u00C9tat/province\u00A0:',
    'settingsStoresStoreRegion': 'R\u00E9gion\u00A0',
    'settingsStoresZip': 'Code Zip/postal\u00A0:',
    'settingsStoresCountry': 'Pays\u00A0:',
    'settingsStoresPhone': 'T\u00E9l\u00E9phone\u00A0:',
    'settingsStoresFax': 'T\u00E9l\u00E9copieur\u00A0:',
    'settingsStoresCancel': 'Annuler',
    'settingsStoresRegisteredSystems': 'Syst\u00E8mes enregistr\u00E9s',
    'settingsStoresSystemName': 'Nom du syst\u00E8me',
    'settingsStoresSystemVersion': 'Version du syst\u00E8me',
    'settingsStoresSerialNumber': 'Num\u00E9ro de s\u00E9rie',
    'settingsStoresSystemStatus': '\u00C9tat du syst\u00E8me',
    'settingsStoresOnline': 'En ligne',
    'settingsStoresOffline': 'Hors ligne',
    'settingsStoresNotAvailable': 'Non disponible',
    'settingsStoresViewDetails': 'Afficher les d\u00E9tails',
    'storeSettingsConfirmUpdateSucessful': 'Mise \u00E0 jour r\u00E9ussie!',
    'storeSettingsConfirmError': 'Les erreurs suivantes se sont produites pendant le traitement de votre demande\u00A0:',
    'storeSettingsConfirmTransferSucessful': 'Transfert r\u00E9ussi!',
    'storeSettingsConfirmFiveMinuteNotice1': 'Veuillez noter\u00A0:',
    'storeSettingsConfirmFiveMinuteNotice2': 'Les changements de param\u00E8tres prennent environ 5\u00A0minutes pour entrer en vigueur.',
    'storeSettingsConfirmUpgradeSucessful': 'Mises \u00E0 jour r\u00E9ussies!',
    'storeListRecordSaved': 'Enregistrement sauvegard\u00E9!',
    'storeListRecordRemoved': 'Enregistrement supprim\u00E9!',
    'storeListStores': 'Restaurants',
    'storeListStoreDetails': 'D\u00E9tails du restaurant',
    'settingsStoresCIBSettings': 'Param\u00E8tres CIB',
    'settingsStoresCIBEmail': 'Courriel\u00A0: ',
    'settingsStoresCIBBrand': 'Marque\u00A0 ',
    'settingsStoresCIBTimeZone': 'Fuseau horaire\u00A0: ',
    'settingsStoresRegisteredCIB': 'CIB enregistr\u00E9\u00A0:',
    'settingsStoresCorporateStore': 'Restaurant de l\u2019entreprise\u00A0',
    'settingsStoresNoStores': 'Vous n\u2019avez aucun restaurant',
    'settingsStoresLoadingMessage1': 'Veuillez patienter pendant le traitement de votre demande...',
    'settingsStoresLoadingMessage2': 'Veuillez noter\u00A0: Selon la quantit\u00E9 de donn\u00E9es demand\u00E9es, le chargement peut prendre un certain temps.',
    'settingsStoresAreYouSure': 'Voulez-vous vraiment mettre \u00E0 jour les restaurants s\u00E9lectionn\u00E9s?',
    'settingsStoresRegisteredEOS': 'EOS enregistr\u00E9\u00A0:',
    'settingsStoresRegisteredION': 'ION enregistr\u00E9\u00A0:',
    'settingsStoresRegisteredZOOM': 'ZOOM enregistr\u00E9\u00A0:',
    'settingsStoresDetails': 'd\u00E9tails',
    'settingsUsersDetails': 'Utilisateur',
    'settingsStoresUnavailable': 'Non disponible',
    'secondswithabb': 'Secondes (sec)',
    'minuteswithabb': 'Minutes (min:sec)',
    'SelectAStore': 'Choisissez un restaurant',
    'savesuccessful': 'Sauvegarde r\u00E9ussie!',
    'pleasefillinfirstname': 'Veuillez indiquer le pr\u00E9nom de l\u2019utilisateur.',
    'pleasefillinlastname': 'Veuillez indiquer le nom de famille de l\u2019utilisateur.',
    'new': 'Nouveau',
    'confirmed': 'Confirm\u00E9',
    'passwordnotmatchsystem': 'Le mot de passe ne figure pas dans notre syst\u00E8me.',
    'selectallapply': 'Choisissez toutes les valeurs qui s\u2019appliquent',
    'pleaseassignrole': 'Veuillez attribuer un r\u00F4le \u00E0 l\u2019utilisateur.',
    'selectuserstatus': 'Veuillez choisir l\u2019\u00E9tat de l\u2019utilisateur.',
    'useremailalready': 'L\u2019adresse courriel de l\u2019utilisateur est d\u00E9j\u00E0 utilis\u00E9e.',
    'rolenotfound': 'R\u00F4le introuvable.',
    'userrecordnotfound': 'Enregistrement de l\u2019utilisateur introuvable.',
    'willrecieveemail': 'recevra un courriel contenant les identifiants n\u00E9cessaires pour se connecter.',
    'theuser': 'L\u2019utilisateur',
    'download': 'T\u00E9l\u00E9charger',
    'companyblank': 'Il faut indiquer un nom d\u2019entreprise.',
    'companyaddressblank': 'Veuillez entrer l\u2019adresse de votre entreprise.',
    'companycityblank': 'Veuillez entrer la ville de votre entreprise.',
    'zipcodeblank': 'Veuillez entrer votre code postal ou zip.',
    'zipcodeinvalid': 'Veuillez entrer un code postal ou zip valide.',
    'companyphoneblank': 'Veuillez entrer le num\u00E9ro de t\u00E9l\u00E9phone de votre entreprise.',
    'settingsStoresErrorPickBrand': 'Veuillez choisir une marque.',
    'settingsStoresErrorNeedsStoreNum': 'Veuillez entrer le num\u00E9ro de votre restaurant',
    'settingsStoresErrorNeedsAddress': 'Veuillez entrer l\u2019adresse de votre restaurant.',
    'settingsStoresErrorNeedsCity': 'Veuillez entrer la ville de votre restaurant',
    'settingsStoresErrorNeedsState': 'Veuillez entrer votre \u00E9tat ou votre province.',
    'settingsStoresErrorNeedsZip': 'Veuillez entrer votre code postal ou zip.',
    'settingsStoresErrorNeedsZip2': 'Veuillez entrer un code postal ou zip valide.',
    'settingsStoresErrorNeedsNumber': 'Veuillez entrer le num\u00E9ro de t\u00E9l\u00E9phone de votre restaurant.',
    'settingsStoresErrorNeedsNewAddress': 'Cette adresse est d\u00E9j\u00E0 utilis\u00E9e. Veuillez entrer une adresse unique.',
    'storeSettingsConfirmDeletion': 'Voulez-vous vraiment supprimer ce restaurant?\nCette action ne peut pas \u00EAtre annul\u00E9e.',
    'StoreSettingsHeaderBrand': 'Marque\u00A0',
    'StoreSettingsHeaderStore': 'Restaurant',
    'StoreSettingsHeaderAddress': 'Adresse du restaurant.',
    'StoreSettingsHeaderCityState': 'Ville, \u00C9tat/province',
    'StoreSettingsHeaderName': 'Nom du syst\u00E8me',
    'StoreSettingsHeaderVersion': 'Version du syst\u00E8me',
    'StoreSettingsHeaderStatus': '\u00C9tat du syst\u00E8me',
    'StoreSettingsErrorSelectionInvalid': 'Veuillez choisir un restaurant valide.',
    'StoreSettingsErrorNameInvalid': 'Veuillez entrer un nom de restaurant appropri\u00E9.',
    'StoreSettingsErrorProcessing': 'Une erreur est survenue pendant le traitement de votre requ\u00EAte. Veuillez essayer de nouveau plus tard.',
    'StoreSettingsErrorReachingQueue': 'File d\u2019attente inatteignable. Veuillez soumettre votre requ\u00EAte de nouveau plus tard.',
    'StoreSettingsErrorSystemOffline': 'Le syst\u00E8me doit \u00EAtre en ligne pour en changer les param\u00E8tres.',
    'StoreSettingsErrorMakeSelection': 'Vous devez choisir au moins 1\u00A0syst\u00E8me pour changer les param\u00E8tres.',
    'systemSettingsZoomUnreachable': 'Syst\u00E8me ZOOM inatteignable. Veuillez soumettre votre requ\u00EAte de nouveau plus tard.',
    'systemSettingsNoSelection': 'Vous devez choisir au moins 1\u00A0syst\u00E8me pour lancer les mises \u00E0 jour.',
    'newFeaturesHeader': 'Enregistrer les mod\u00E8les de rapport',
    'newFeaturesFeature1': 'Vous pouvez maintenant enregistrer n\u2019importe quel rapport gr\u00E2ce \u00E0 la fonction \u00AB\u00A0Enregistrer les mod\u00E8les de rapport\u00A0\u00BB',
    'newFeaturesFeature2': 'G\u00E9n\u00E9rez un rapport comme vous le feriez normalement, dans le g\u00E9n\u00E9rateur de rapports.',
    'newFeaturesFeature3': 'Cochez la case \u00AB\u00A0Enregistrer comme mod\u00E8le\u00A0\u00BB et donnez un nom au rapport.',
    'newFeaturesFeature4': 'Cliquez sur \u00AB\u00A0G\u00E9n\u00E9rer rapport\u00A0\u00BB',
    'newFeaturesFeature5': 'Ce rapport appara\u00EEtra dor\u00E9navant dans la liste des \u00AB\u00A0Mod\u00E8les de rapport enregistr\u00E9s\u00A0\u00BB',
    'newFeaturesFeature6': 'Les utilisateurs peuvent enregistrer jusqu\u2019\u00E0 10\u00A0mod\u00E8les.',
    'newFeaturesFeature7': 'Pour r\u00E9utiliser un mod\u00E8le, il suffit de cliquer sur le nom du rapport que vous d\u00E9sirez g\u00E9n\u00E9rer, puis de cliquer sur \u00AB\u00A0G\u00E9n\u00E9rer rapport\u00A0\u00BB.',
    'newFeaturesMajorHeader': 'Nouvelles fonctions de HME CLOUD',
    'dashboardcustomization': 'Personnalisation du tableau de bord r\u00E9ussie!',
    'pleaseselectdashboard': 'Veuillez choisir un tableau de bord valide.',
    'pleaseselectdashboardorder': 'Veuillez choisir un ordre de tableau de bord valide.',
    'deleteroledialog': 'Voulez-vous vraiment supprimer ce r\u00F4le?\nCette action ne peut pas \u00EAtre annul\u00E9e.',
    'rolehasuser': 'ne peuvent pas être supprimés avec les utilisateurs affectés. sil vous plaît ré-attribuer ces (1) les utilisateurs avant de deleteing ce rôle.',
    'savechanges': 'Enregistrer les changements',
    'confirm': 'Confirmer',
    'userremoved': 'Utilisateur supprim\u00E9!',
    'leaderboardsettings': 'Param\u00E8tres de Leaderboard',
    'resettodefaults': 'R\u00E9initialiser aux valeurs initiales',
    'customizeleaderboard': 'Personnaliser Leaderboard',
    'createcustombyselecting': 'Pour créer un tableau de bord personnalisé, commencez pas choisir une mesure du temps',
    'usingplussign': 'en utilisant le signe plus dans une colonne ouverte.',
    'toremovekpi': 'Pour supprimer un IRC',
    'fromatimemeasurement': 'd\u2019une mesure de temps, cliquez sur l\u2019ic\u00F4ne correspondant \u00E0 l\u2019IRC que vous d\u00E9sirez supprimer.',
    'addkpiuseplus': 'Pour ajouter un IRC, cliquez sur le petit symbole plus qui se trouve dans la mesure de temps en cours de configuration.',
    'youmayselectdefault': 'Vous pouvez \u00E9galement choisir un IRC par d\u00E9faut pour \u00E9tablir le classement de tous vos restaurants en utilisant l\u2019ic\u00F4ne correspondant \u00E0 l\u2019IRC que vous d\u00E9sirez utiliser.',
    'torearrangetimemeasurement': 'Pour r\u00E9organiser une mesure de temps ou un IRC d\u2019une mesure de temps, il suffit  de cliquer sur l\u2019ent\u00EAte de colonne vis\u00E9e et de la glisser \u00E0 l\u2019endroit voulu.',
    'validtimemeasure': 'Les mesures de temps valides sont l\u2019heure actuelle, la partie du jour actuelle, l\u2019heure cons\u00E9cutive, l\u2019heure pr\u00E9c\u00E9dente, la partie du jour pr\u00E9c\u00E9dente, le jour pr\u00E9c\u00E9dent et l\u2019heure cons\u00E9cutive pr\u00E9c\u00E9dente.',
    'validkpicars': 'Les indicateurs de rendement cl\u00E9 (IRC) valides sont les voitures, la moyenne et le pourcentage d\u2019objectif.',
    'carsaretotalnumber': 'Les voitures sont le nombre total de voitures compt\u00E9es pendant la mesure de temps indiqu\u00E9e; la moyenne est le temps moyen d\u2019un passage pour l\u2019unit\u00E9 de mesure de temps choisie. Le pourcentage d\u2019objectif est le pourcentage des v\u00E9hicules qui passent en de\u00E7\u00E0 de l\u2019objectif de temps A pour la mesure de temps choisie. ',
    'primarygoalcolors': 'Couleur des objectifs principaux',
    'selectcustomgoalcolor': 'Choisissez une couleur personnalis\u00E9e d\u2019objectif pour vos objectifs principal A, B et plus de B \u00E0 l\u2019aide du s\u00E9lecteur de couleurs.',
    'thesecolorsallow': 'Ces couleurs vous permettront d\u2019identifier facilement les mesures de rendement pour chacun de vos restaurants.',
    'youcanmanuallyenterhex': 'Si vous pr\u00E9f\u00E9rez, vous pouvez \u00E9galement entrer manuellement la valeur hexad\u00E9cimale de la couleur choisie.',
    'timeformat': 'Format de l\u2019heure\u00A0',
    'selectdefaulttime': 'Choisissez le format d\u2019heure par d\u00E9faut',
    'thatwillbeshowndashboard': 'qui sera utilis\u00E9 pour l\u2019affichage sur vos tableaux de bords et vos rapports.',
    'timeformatmaybeshown': 'Le format d\u2019heure peut \u00EAtre affich\u00E9 en minutes:secondes ou en secondes.',
    'Pullins': 'Entr\u00E9es',
    'fordashchoosepull': 'Vous pouvez choisir d\u2019inclure ou non les donn\u00E9es d\u2019entr\u00E9e tardive de v\u00E9hicule dans les tableaux de bord',
    'dataorexclude': 'et les rapports.',
    'apullinisavehicle': 'Une entr\u00E9e tardive est un v\u00E9hicule qui est entr\u00E9 dans l\u2019ann\u00E9e du service au volant apr\u00E8s le premier point de d\u00E9tection activ\u00E9 et qui en est sorti apr\u00E8s le dernier point de d\u00E9tection activ\u00E9.',
    'language': 'Langue',
    'changethelanguage': 'Changer la langue',
    'seconds': 'Secondes',
    'minutesseconds': 'Minutes:Secondes',
    'currentrollinghour': 'Heure cons\u00E9cutive actuelle',
    'Stores': 'Restaurants',
    'Current Hour': 'Heure actuelle',
    'Previous Hour': 'Heure pr\u00E9c\u00E9dente',
    'Current Day': 'Jour actuel',
    'Previous Day': 'Jour pr\u00E9c\u00E9dent',
    'Current Daypart': 'Partie du jour actuelle',
    'Previous Daypart': 'Partie du jour pr\u00E9c\u00E9dente',
    'Current Rolling Hour': 'H. cons. actu.',
    'Current Rollinghour': 'H. cons. actu.',
    'Previous Rolling Hour': 'H. cons. pr\u00E9c',
    'current hour': 'Heure actuelle',
    'previous hour': 'Heure pr\u00E9c\u00E9dente',
    'current day': 'Jour actuel',
    'previous day': 'Jour pr\u00E9c\u00E9dent',
    'current daypart': 'Partie du jour actuelle',
    'previous daypart': 'Partie du jour pr\u00E9c\u00E9dente',
    'current rolling hour': 'H. cons. actu.',
    'current rollinghour': 'H. cons. actu.',
    'previous rolling hour': 'H. cons. pr\u00E9c',
    'previous rollinghour': 'H. cons. pr\u00E9c',
    'Rank': 'Rang',
    'ranking': 'Ranking',
    'Store': 'Restaurant',
    'Name': 'Nom',
    'Goal': 'Objectif',
    'Cars': 'Voitures',
    'Avg': 'Moy',
    'Goal%': 'Object%',
    'setdefaultsort': 'Configurer le tri par d\u00E9faut',
    'removecolumm': 'Retirer la colonne',
    'leaderboardCustomSuccess': 'Personnalisation de Leaderboard r\u00E9ussie! Les changements entreront en vigueur \u00E0 la prochaine actualisation de la page.',
    'leaderboardResetSuccess': 'R\u00E9initialisation de Leaderboard r\u00E9ussie! Les changements entreront en vigueur \u00E0 la prochaine actualisation de la page.',
    'createacustomizeddashboard': 'Pour cr\u00E9er un tableau de bord personnalis\u00E9, commencez pas choisir une mesure de temps',
    'usingtheplussign': 'en utilisant le signe plus dans une colonne ouverte.',
    'toaddakpi': 'Pour ajouter un IRC, cliquez sur le petit symbole plus qui se trouve dans la mesure de temps en cours de configuration.',
    'youmayalsoselectdefaultKPI': 'Vous pouvez \u00E9galement choisir un IRC par d\u00E9faut pour \u00E9tablir le classement de tous vos restaurants en utilisant l\u2019ic\u00F4ne correspondant \u00E0 l\u2019IRC que vous d\u00E9sirez utiliser.',
    'rearrangeanytimemeasurement': 'Pour r\u00E9organiser une mesure de temps ou un IRC d\u2019une mesure de temps, il suffit  de cliquer sur l\u2019ent\u00EAte de colonne vis\u00E9e et de la glisser \u00E0 l\u2019endroit voulu.',
    'validtimemeasurements': 'Les mesures de temps valides sont la partie du jour actuelle, la journ\u00E9e actuelle, la semaine actuelle, le mois actuel, la partie du jour pr\u00E9c\u00E9dente, le jour pr\u00E9c\u00E9dent, la semaine pr\u00E9c\u00E9dente et le mois pr\u00E9c\u00E9dent.',
    'validkpis': 'Les indicateurs de rendement cl\u00E9 (IRC) valides sont les voitures, la moyenne et le pourcentage d\u2019objectif.',
    'carsarethetotal': 'Les voitures sont le nombre total de voitures compt\u00E9es pendant la mesure de temps indiqu\u00E9e; la moyenne est le temps moyen d\u2019un passage pour l\u2019unit\u00E9 de mesure de temps choisie. Le pourcentage d\u2019objectif est le pourcentage des v\u00E9hicules qui passent en de\u00E7\u00E0 de l\u2019objectif de temps A pour la mesure de temps choisie.',
    'Current Week': 'Semaine actuelle',
    'Previous Week': 'Semaine pr\u00E9c\u00E9dente',
    'Current Month': 'Mois actuel',
    'Previous Month': 'Mois pr\u00E9c\u00E9dent',
    'current week': 'Semaine actuelle',
    'previous week': 'Semaine pr\u00E9c\u00E9dente',
    'current month': 'Mois actuel',
    'previous month': 'Mois pr\u00E9c\u00E9dent',
    'selectatleastinecolumn': 'Vous devez choisir au moins une colonne de donn\u00E9es.',
    'error': 'Erreur!',
    'AddRole': 'Ajouter r\u00F4le',
    'AddUser': 'Ajouter utilisateur',
    'EditRole': 'Modifier r\u00F4le',
    'RemoveUser': 'Retirer utilisateur',
    'EditStoreBasic': 'Modifier info de base du restaurant',
    'EditUser': 'Modifier utilisateur',
    'RemoteConnect': 'Connexion \u00E0 distance',
    'RemoveRole': 'Supprimer r\u00F4le',
    'EditLeaderboard': 'Modifier Leaderboard',
    'PerformDeviceRestart': 'Red\u00E9marrer le dispositif',
    'ViewAllStores': 'Afficher tous les restaurants',
    'EditDeviceSettings': "Modifier Les Paramètres De L'Appareil",
    'Basic': 'De base',
    'Admin': 'Admin',
    'Owner': 'Proprietaire',
    'rolenameblank': 'Vous devez indiquer un nom de r\u00F4le',
    'pleaseselectonepermission': 'Veuillez choisir au moins une permission pour ce r\u00F4le',
    'rolenameinvalid': 'R\u00F4le non valide.',
    'roleremoved': 'R\u00F4le supprim\u00E9!',
    'cannotbedeleted': 'impossible de supprimer, car des utilisateurs y sont attribu\u00E9s. Veuillez r\u00E9-attribuer',
    'usersbeforedeleting': 'ces utilisateurs avant de supprimer ce r\u00F4le.',
    'storerankingbylane': 'Classement de restaurant par temps moyen total par all\u00E9e.',
    'top3stores': '3 meilleurs restaurants',
    'lanetransactions': 'Transaction par all\u00E9e',
    'TRANSACTIONS': 'TRANSACTIONS',
    'AVG TIME (sec)': 'TEMPS MOY (sec)',
    'lanetotalavgtime': 'Temps moy total all\u00E9e',
    'Queue': 'File d\u2019attente',
    'Service': 'Service',
    'Menu Board': 'Tableau-menu',
    'CURRENT DP': 'PJ ACTUELLE',
    'null': 'nul',
    'Lane Total': 'Total all\u00E9e',
    'Lane 1 Total': 'Total 1 all\u00E9e',
    'Lane 1 Total 2': 'Total 1 all\u00E9e 2',
    'Lane 2 Total': 'Total 2 all\u00E9e',
    'Lane 2 Total 2': 'Total 2 all\u00E9e 2',
    'Average Current': 'Moyenne courante',
    'Status': '\u00C9tat',
    'Please wait while your dashboard': 'Votre tableau de bord est g\u00E9n\u00E9r\u00E9, veuillez patienter...',
    'Please Note: This dashboard': 'Veuillez noter\u00A0: Selon la quantit\u00E9 de donn\u00E9es demand\u00E9es, le chargement du tableau de bord peut prendre un certain temps.',
    'Daypart': 'Partie du jour',
    'Store ': 'Restaurant ',
    'bottom3Stores': 'Les moins performants',
    'invalidreporttemplate': 'Mod\u00E8le de rapport non valide',
    'pleaseselectopentime': 'Veuillez choisir une heure d\u2019ouverture',
    'pleaseselectclosetime': 'Veuillez choisir une heure de fermeture',
    'pleaseselectstore': 'Veuillez choisir un restaurant',
    'invalidselectiononestore': 'S\u00E9lection non valide Veuillez ne pas choisir plus d\u2019un restaurant pour un rapport de donn\u00E9es brutes',
    'Please select a Start Date': 'Veuillez choisir une date de d\u00E9but',
    'Please select an End Date': 'Veuillez choisir une date de fin',
    'daterangeinvalid3month': 'Plage de dates non valide Pour g\u00E9n\u00E9rer un rapport \u00E0 options \u00E9volu\u00E9es, choisissez n\u2019importe quelle p\u00E9riode de trois mois',
    'daterangeinvalid2week': 'Plage de dates non valide Pour g\u00E9n\u00E9rer un rapport par partie du jour, choisissez n\u2019importe quelle p\u00E9riode de deux semaines.',
    'daterangeinvalid2month': 'Plage de dates non valide Pour g\u00E9n\u00E9rer un rapport par semaine, choisissez n\u2019importe quelle p\u00E9riode de deux mois.',
    'daterangeinvalidmonthreport3month': 'Plage de dates non valide Pour g\u00E9n\u00E9rer un rapport de mois, choisissez n\u2019importe quelle p\u00E9riode de trois mois.',
    'daterangeinvalidsingleday': 'Plage de dates non valide Pour g\u00E9n\u00E9rer un rapport de donn\u00E9es brutes, choisissez une seule journ\u00E9e.',
    'daterangeinvalid1month': 'Plage de dates non valide Pour g\u00E9n\u00E9rer un rapport de jour, choisissez n\u2019importe quelle p\u00E9riode de un mois.',
    'daterangeinvalidbeyond': 'Plage de dates non valide La date de d\u00E9part ne peut pas \u00EAtre apr\u00E8s la date de fin.',
    'storeselectioninvalid1000': 'Restaurant choisi non valide Vous pouvez choisir jusqu\u2019\u00E0 1000\u00A0restaurants dans la liste ci-dessous.',
    'storeselectioninvalid100': 'Restaurant choisi non valide Vous pouvez choisir jusqu\u2019\u00E0 100\u00A0restaurants dans la liste ci-dessous.',
    'pleaseneteratemplatename': 'Veuillez entrer le nom du mod\u00E8le \u00E0 enregistrer.',
    'savedtemplatelimit': 'Vous avez atteint la limite de 10\u00A0mod\u00E8les enregistr\u00E9s. Avant d\u2019enregistrer un nouveau mod\u00E8le, vous devez d\u2019abord en supprimer un.',
    'pleaseenterauniquetemplate': 'Veuillez entrer un nom de mod\u00E8le unique pour enregistrer ce mod\u00E8le.',
    'pleasechecksaveastemplate': 'Veuillez cocher la case Enregistrer comme mod\u00E8le et entrer un nom de mod\u00E8le pour enregistrer le mod\u00E8le.',
    'Rolling Hour': 'Heure cons\u00E9cutive',
    'Previous Full Hour': 'Heure compl\u00E8te pr\u00E9c\u00E9dente',
    'Previous Full Rolling Hour': 'Heure cons\u00E9cutive compl\u00E8te pr\u00E9c\u00E9dente',
    'Previous Full Rollinghour': 'Heure cons\u00E9cutive compl\u00E8te pr\u00E9c\u00E9dente',
    'Previous Full Day': 'Journ\u00E9e compl\u00E8te pr\u00E9c\u00E9dente',
    'Previous Full Daypart': 'Partie du jour compl\u00E8te pr\u00E9c\u00E9dente',
    'Previous Full Week': 'Semaine compl\u00E8te pr\u00E9c\u00E9dente',
    'Previous Full Month': 'Mois complet pr\u00E9c\u00E9dent',
    'ReportsSummarizedReport': 'Rapport sommaire',
    'ReportsStart': 'Heure de d\u00E9but: ',
    'ReportsEnd': 'Heure de fin: ',
    'ReportsPrintDate': 'Date d\u2019impression:',
    'ReportsPrintTime': 'Heure d\u2019impression:',
    'ReportsPage': 'Page ',
    'ReportsOf': 'sur ',
    'ReportsOpen': 'OUVERT.',
    'ReportsClose': 'FERMET.',
    'ReportsStop': 'Temps d\u2019arr\u00EAt\u00A0: ',
    'ReportsLongest': 'Temps',
    'ReportsTimes': 'le plus long',
    'ReportsGoalsStatsFor': 'STATISTIQUES D\u2019OBJECTIF POUR',
    'ReportsAveragePerformancePerEvent': 'LE RENDEMENT MOYEN PAR \u00C9V\u00C9NEMENT',
    'ReportsGoalA': 'Objectif A',
    'ReportsGoalB': 'Objectif B',
    'ReportsGoalC': 'Objectif C',
    'ReportsGoalD': 'Objectif D',
    'ReportsDerivedPerformancetoGoal': ' Rendement d\u00E9riv\u00E9 de l\u2019objectif (objectif de file d\u2019attente de l\u2019all\u00E9e = Objectif total de l\u2019all\u00E9e - Objectif de menu - objectif de service)',
    'ReportsLane': 'All\u00E9e',
    'ReportsAverageCarsInLane': 'Nbre moyen de voiture dans l\u2019all\u00E9e',
    'ReportsTotalPullouts': 'Total de d\u00E9parts anticip\u00E9s',
    'ReportsTotalPullins': 'Total des entr\u00E9es tardives',
    'ReportsDeleteOverMax': 'Supprimer au-dessus du maximum',
    'ReportsPowerFails': 'Panne de courant',
    'ReportsSystemResets': 'R\u00E9initialisation de syst\u00E8me',
    'ReportsVBDResets': 'R\u00E9initialisation VBD',
    'ReportsLoadingPleaseWait': 'Votre rapport est g\u00E9n\u00E9r\u00E9, veuillez patienter...',
    'ReportsPleaseNote': 'Veuillez noter\u00A0: Selon la quantit\u00E9 de donn\u00E9es demand\u00E9es, le rapport peut prendre un certain temps.',
    'Default Dashboard View': 'Affichage par d\u00E9faut du tableau de bord',
    'Display Settings': 'Param\u00E8tres d\u2019affichage',
    'Select a default view for your': 'Choisissez l\u2019affichage par d\u00E9faut pour votre tableau de bord de restaurant unique et votre tableau de bord multi-restaurant. Choisissez soit la partie du jour, la journ\u00E9e, la semaine, le mois ou une dur\u00E9e personnalis\u00E9e.',
    'This will be the view you': 'Cet affichage sera celui que vous verrez lorsque vous cliquez sur le lien de tableau de bord ZOOM dans la barre de navigation.',
    'You must first configure a customized': 'Vous devez commencer par configurer un tableau de bord personnalis\u00E9 avant de choisir des options de personnalisation comme l\u2019affichage par d\u00E9faut.',
    'Select a custom goal color': 'Choisissez une couleur personnalis\u00E9e d\u2019objectif pour vos objectifs principal A, B et plus de B \u00E0 l\u2019aide du s\u00E9lecteur de couleurs.',
    'These colors will allow you to easily': 'Ces couleurs vous permettront d\u2019identifier facilement les mesures de rendement pour chacun de vos restaurants.',
    'You can also manually enter the hexadecimal': 'Si vous pr\u00E9f\u00E9rez, vous pouvez \u00E9galement entrer manuellement la valeur hexad\u00E9cimale de la couleur choisie.',
    'Select the default time format': 'Choisissez le format d\u2019heure par d\u00E9faut',
    'that will be shown on your': 'qui sera utilis\u00E9 pour l\u2019affichage sur vos tableaux de bords et vos rapports.',
    'Time format may be shown in minutes:seconds': 'Le format d\u2019heure peut \u00EAtre affich\u00E9 en minutes:secondes ou en secondes.',
    'For dashboards and reports': 'Vous pouvez choisir d\u2019inclure ou non les donn\u00E9es d\u2019entr\u00E9e tardive de v\u00E9hicule dans les tableaux de bord',
    'data or exclude it': 'et les rapports.',
    'A pull-in is a vehicle that entered': 'Une entr\u00E9e tardive est un v\u00E9hicule qui est entr\u00E9 dans l\u2019ann\u00E9e du service au volant apr\u00E8s le premier point de d\u00E9tection activ\u00E9 et qui en est sorti apr\u00E8s le dernier point de d\u00E9tection activ\u00E9.',
    'Store abbrev': 'Restaurant',
    'Display Settings changes successful': 'Param\u00E8tres d\u2019affichage modifi\u00E9s.',
    'ReportsAll': 'Tous',
    'ReportsAverageTime': 'TEMPS MOYEN',
    'ReportsWeightedAverage': '(W-Moy)',
    'ReportsShow': 'Afficher',
    'ReportsTotalCars': 'Total voitures',
    'Total Cars': 'Total voitures',
    'ReportsPages': 'Pages',
    'ReportsOr': 'OU',
    'Order': 'Ordre',
    'Order Point1': 'Ordre Point1',
    'Order Point2': 'Ordre Point2',
    'Order1': 'Ordre1',
    'Order2': 'Ordre2',
    'Greet': 'Accueil',
    'Greet1': 'Accueil 1',
    'Greet2': 'Accueil 2',
    'Greet 1': 'Accueil 1',
    'Greet 2': 'Accueil 2',
    'Cashier': 'Caisse',
    'Pickup': 'Ramassage',
    'LaneQueue': 'File d\u2019attente de l\u2019all\u00E9e',
    'Lane Queue': 'File d\u2019attente de l\u2019all\u00E9e',
    'Lane Queue 2': 'File d\u2019attente de l\u2019all\u00E9e 2',
    'Metrics': 'Metriques:',
    'LaneTotal': 'Total all\u00E9e',
    'Lane Total 2': 'Total all\u00E9e 2',
    'LaneTotal2': "Total de l'all\u00E9e 2",
    'dashboardonly': '(Tableau de bord)',
    'MenuBoard1': 'Tableau-menu1',
    'MenuBoard2': 'Tableau-menu2',
    'Menu Board1': 'Tableau-menu1',
    'Menu Board2': 'Tableau-menu2',
    'MenuBoard': 'Menu',
    'OPEN': 'OUVERT.',
    'CLOSE': 'FERMET.',
    'Rolehasuser': 'Rôle',
    'CUSTOM': 'PERSONNALIS\u00C9',
    'MONTH': 'MOIS',
    'WEEK': 'SEMAINE',
    'DAY': 'JOUR',
    'DAYPART': 'PARTIE DU JOUR',
    'HOUR': 'HEURE',
    'permissions': 'Permissions',
    'Current:': 'Actuel\u00A0:',
    'bottom3stores': '3 restaurants les moins performants',
    'yourranking': 'Votre rang',
    'ReportsEmailCSVVersion': 'CSV par courriel',
    'ReportsRawDataReport': 'Rapport de donn\u00E9es brutes sur les voitures',
    'ReportsNoRecordsFound': 'Aucun enregistrement trouv\u00E9',
    'NoRecordsFound': 'Aucun enregistrement trouv\u00E9',
    'ReportsDepartureTime': 'Heure de d\u00E9part',
    'ReportsEventName': 'Nom de l\u2019\u00E9v\u00E9nement',
    'ReportsCarsinQueue': 'Voitures dans la file',
    'Car_Departure': 'Depart_de_voiture',
    'Description': 'Description',
    'HelpFrequentlyAskedQs': 'Questions fr\u00E9quemment pos\u00E9es',
    'HelpOperatingInstructions': 'Instructions d\u2019utilisation de HME CLOUD',
    'HelpNewFeatures': 'Nouvelles fonctions',
    'HelpNewDashboardOrReport': 'Comment puis-je cr\u00E9er un rapport ou un tableau de bord personnalis\u00E9?',
    'HelpContactYourSalesRep': 'Communiquez avec votre repr\u00E9sentant ou votre d\u00E9taillant pour discuter de vos options.',
    'HelpHowChangePassword': 'Comment puis-je changer mon mot de passe?',
    'HelpSignInClickOnMyAccount': 'Connectez-vous et cliquez sur Mon compte.',
    'HelpWhatIfForgotPass': 'Et si j\u2019ai oubli\u00E9 mon mot de passe?',
    'HelpGoHomeClickForgotPass': 'Rendez-vous \u00E0 la page d\u2019accueil de HME CLOUD et cliquez sur \u00AB\u00A0I forgot my password\u00A0\u00BB.',
    'HelpHowSetDayparts': 'Comment puis-je configurer mes parties du jour pour le tableau de bord et les rapports de HME CLOUD pour que je puisse voir l\u2019information dont j\u2019ai besoin?',
    'HelpAllSettingsInDashboard': 'Tous vos r\u00E9glages de minuterie ZOOM sont t\u00E9l\u00E9vers\u00E9s automatiquement et affich\u00E9s dans votre tableau de bord et vos rapports de HME CLOUD.',
    'HelpWhatAreRoles': 'En tant qu\u2019administrateur d\u2019entreprise qui ajoute plus d\u2019utilisateurs \u00E0 mon compte, quelle est la diff\u00E9rence entre ajoutera 1) un administrateur d\u2019entreprise; 2) un directeur de district; 3) un directeur r\u00E9gional; 4) un g\u00E9rant de restaurant?',
    'HelpCompanyAdminPowers': 'Un administrateur d\u2019entreprise peut cr\u00E9er d\u2019autres utilisateurs et peut acc\u00E9der \u00E0 des fonctions telles que R\u00E9initialiser le syst\u00E8me et Forcer la reconnexion.',
    'HelpCompanyManagerPowers': 'Les directeurs de district, les directeurs r\u00E9gionaux et les g\u00E9rants de restaurant ne peuvent pas acc\u00E9der aux fonctions Red\u00E9marrer le syst\u00E8me\u00A0et Forcer la reconnexion, ni cr\u00E9er des utilisateurs.',
    'HelpDeterminePermissionLevel': 'Comment puis-je savoir quel est mon niveau d\u2019autorisation?',
    'HelpPermissionLevelIsOnMyAccount': 'Cliquez sur Mon compte et affichez votre niveau d\u2019autorisation dans la section Information sur l\u2019utilisateur.',
    'HelpUpdateEmployeeList': 'Que dois-je faire si un employ\u00E9 quitte son poste et que je dois mettre \u00E0 jour ma liste d\u2019utilisateurs?',
    'HelpAccessUserList': 'Acc\u00E9dez \u00E0 la page \u00AB\u00A0Utilisateurs\u00A0\u00BB, puis cliquez sur le lien Voir/modifier utilisateur pour mettre \u00E0 jour le nom d\u2019utilisateur (adresse de courriel) et la liste de v\u00E9rification d\u2019acc\u00E8s au restaurant.',
    'HelpAccessZoomSettingsRemotely': 'Comment puis-je changer mes param\u00E8tres ZOOM \u00E0 distance?',
    'HelpAccessZoomSettingsInstructions': 'Cliquez sur Restaurants, puis sur En ligne, dans la colonne de droite.  L\u2019affichage du portail Web ZOOM peut prendre quelques secondes.  Cliquez sur l\u2019ic\u00F4ne d\u2019engrenage dans le coin sup\u00E9rieur droit pour acc\u00E9der aux param\u00E8tres ZOOM.',
    'HelpSubscription': 'Abonnement',
    'HelpDoSubscriptionsRenew': 'Mon abonnement se renouvelle-t-il automatiquement chaque ann\u00E9e?',
    'HelpYesSubscriptionsRenew': 'Votre abonnement se renouvellera pour tous vos restaurants chaque ann\u00E9e, \u00E0 la date d\u2019anniversaire de votre abonnement.',
    'HelpWhenSubscriptionExpires': 'Comment puis-je conna\u00EEtre la date d\u2019\u00E9ch\u00E9ance de mon abonnement?',
    'HelpContactTechSupport': 'Communiquez avec le soutien technique de HME, au 1\u00A0800\u00A0848-4468, options 1, 2, 3. Ils pourront vous dire quand votre abonnement arrive \u00E0 \u00E9ch\u00E9ance et quand commence votre nouvelle ann\u00E9e de service',
    'HelpCancelMySubscription': 'Comment puis-je annuler mon abonnement?',
    'HelpCancelationInstructions': 'Si vous d\u00E9sirez annuler votre abonnement, veuillez communiquer avec votre repr\u00E9sentant ou d\u00E9taillant HME.',
    'HelpAddingStoresFullPrice': 'SI j\u2019ajoute un restaurant \u00E0 mon abonnement, dois-je payer pour l\u2019ann\u00E9e compl\u00E8te?',
    'HelpAddingStoresDiscountedPrice': 'Vous serez factur\u00E9 pour le nombre de mois restant avant le renouvellement de votre abonnement.',
    'HelpTroubleshooting': 'D\u00E9pannage',
    'HelpDashboardNoContent': 'Lorsque je clique sur Tableau de bord ou sur Rapports, aucun contenu n\u2019est affich\u00E9.',
    'HelpYouMayNeedPremium': 'Vous pourriez avoir besoin d\u2019un abonnement Premium. Pour vous abonner \u00E0 HME CLOUD et en obtenir l\u2019acc\u00E8s complet, communiquez avec votre repr\u00E9sentant HME.',
    'HelpNewZoomNotShowing': 'J\u2019ai install\u00E9 une nouvelle minuterie ZOOM, mais n\u2019est pas affich\u00E9e dans mon compte HME CLOUD comme un de mes restaurants.',
    'HelpConfirmZoomConfigured': 'Quelques configurations essentielles permettent de faire reconna\u00EEtre la minuterie ZOOM par HME CLOUS et votre compte.',
    'HelpConfirmFirmwareVersion': 'Assurez-vous que votre micrologiciel est la version 2.0\u00A0ou une version plus r\u00E9cente..',
    'HelpConfirmAdminStatus': 'Si vous n\u2019avez pas un compte d\u2019administrateur d\u2019entreprise (p. ex., si vous \u00EAtes un g\u00E9rant de restaurant), votre administrateur d\u2019entreprise doit vous affecter des restaurants; vous verrez ensuite ces restaurants dans votre compte.',
    'HelpConfirmTimerOptIn': 'La minuterie doit \u00EAtre configur\u00E9e pour accepter le service HME CLOUD.  Votre installateur ou votre repr\u00E9sentant de service HME peut vous aider \u00E0 v\u00E9rifier la configuration.',
    'HelpVerifyPortsOpen': 'Les ports sortants 18000 et 19000 de votre r\u00E9seau doivent \u00EAtre ouverts.',
    'HelpVerifyActiveAccount': 'Vous devez avoir cr\u00E9\u00E9 un compte utilisateur et l\u2019adresse courriel configur\u00E9e dans la minuterie ZOOM doit correspondre \u00E0 l\u2019adresse courriel (nom d\u2019utilisateur) du compte HME CLOUD.',
    'HelpHowToGetHelp': 'Comme puis-je communiquer avec HME lorsque j\u2019ai besoin d\u2019assistance technique?',
    'HelpContactUs': 'Communiquez avec l\u2019assistance technique de HME en composant le 1\u00A0800\u00A0848-4468, options 1, 2, 3',
    'HelpPossibleInnaccurateData': 'Que dois-je faire si mon tableau de bord n\u2019affiche pas la bonne information?',
    'HelpHandlingMissingData': 'Assurez-vous que vous regardez les donn\u00E9es du bon restaurant.  Si les points de d\u00E9tection de temps sembles inexacts ou qu\u2019il manque de l\u2019information, signalez le probl\u00E8me au service d\u2019assistance technique de HME, qui proc\u00E9dera au d\u00E9pannage.',
    'HelpUnableToConnect': "Quand je tente de me connecter \u00E0 distance \u00E0 mon syst\u00E8me, j'obtiens une erreur \u00AB\u00A0Connexion impossible\u00A0\u00BB. ",
    'HelpConnectingNeedsScripts': 'Certains navigateurs n\u00E9cessitent que l\u2019utilisateur accepte un message de chargement de script avant de permettre le chargement de la page. Chargez la page de nouveau et tentez d\u2019effectuer la connexion \u00E0 distance. Dans le cas des navigateurs Chrome et Firefox, vous verrez appara\u00EEtre un bouclier dans la barre d\u2019adresse. Cliquez sur le bouclier et acceptez le chargement du script. Dans le cas d\u2019Internet Explorer, un message appara\u00EEt au bas de la page pendant quelques secondes; cliquez sur ce message pour accepter le chargement du script. Vous pouvez maintenant effectuer la connexion \u00E0 distance. La plupart des navigateurs se souviendront de votre choix et vous n\u2019aurez pas \u00E0 effectuer cette proc\u00E9dure de nouveau.',
    'HelpSystemStatusUnavailable': 'Dans la liste des restaurants, j\u2019ai remarqu\u00E9 que certains restaurants affichent l\u2019\u00E9tat de syst\u00E8me Non disponible. Qu\u2019est-ce que cela signifie?',
    'HelpStoreIsUnregistered': 'Cela signifie que votre restaurant n\u2019est plus enregistr\u00E9 dans HME CLOUD. Si vous d\u00E9sirez supprimer ce restaurant, cliquez sur Voir/modifier les d\u00E9tails pour ce restaurants, puis cliquez sur Supprimer le lien du restaurant.  Si vous d\u00E9sirez enregistrer le restaurant de nouveau dans HME CLOUD, veuillez communiquer avec le service d\u2019assistance technique de HME au 1\u00A0800\u00A0848-4468, options 1, 2, 3.',
    'HelpContactByEmail': 'Communiquez avec le service d\u2019assistance de HME CLOUD par ',
    'HelpIfAddStoreSub': 'SI j\u2019ajoute un restaurant \u00E0 mon abonnement, dois-je payer pour l\u2019ann\u00E9e compl\u00E8te?',
    'AttemptingConnection': 'Tentative de connexion',
    'RebootStarted': 'Red\u00E9marrage commenc\u00E9',
    'UpgradeStarted': 'Améliorer commenc\u00E9',
    'settingsDevicesFirmwareVersion': 'Version du micrologiciel',
    'settingsDevicesSettingVersion': 'Version des param\u00E8tres',
    'settingsDevicesRegisteredToStoreInfo': 'Enregistr\u00E9 dans les infos du restaurant',
    'settingsDevicesLaneConfiguration': 'Configuration de l\u2019all\u00E9e',
    'settingsDevicesFirstActivity': 'Premi\u00E8re activit\u00E9',
    'settingsDevicesLastActivity': 'Derni\u00E8re activit\u00E9',
    'settingsDevicesNumberOfRecords': 'Nombre d\u2019enregistrements',
    'settingsDevicesUpgrade': 'Mise \u00E0 jour',
    'settingsDevicesReboot': 'Red\u00E9marrage',
    'settingsDevicesForce': 'Forcer',
    'settingsDevicesReconnect': 'Reconnecter',
    'SingleLane': 'All\u00E9e simple',
    'DualLane': 'All\u00E9e double',
    'YLane': 'All\u00E9e en Y',
    'Single Lane': 'All\u00E9e simple',
    'Dual Lane': 'All\u00E9e double',
    'Y Lane': 'All\u00E9e en Y',
    'Please select a Time Format option': 'Veuillez choisir un format de temps.',
    'Please select a Pull-Ins option': 'Veuillez choisir une option d\u2019entr\u00E9e tardive',
    'Please select Primary Goal Colors': 'Veuillez choisir des couleurs d\u2019objectifs principaux.',
    'There has been an error processing your request': 'Une erreur est survenue pendant le traitement de votre requ\u00EAte. Veuillez essayer de nouveau plus tard.',
    'Car_Pull_In': 'Voiture_tirer_dans',
    'Car_Pull_Out': 'Sortie_de_voiture',
    'You are about to be signed out': "Vous etes sur le point d'etre deconnecte pour cause d'inactivite.",
    'YouAreAboutToBeSignedOut': "Vous etes sur le point d'etre deconnecte pour cause d'inactivite.",
    'YouAreCurrentlyViewing': 'Vous consultez actuellement le site en tant que',
    'ContinueViewingAs': 'Continuer à voir en tant que',
    'Stay Logged In': 'Demeurer connect\u00E9',
    'StayLoggedIn': 'Demeurer connect\u00E9',
    'Auto Logout': 'D\u00E9connexion automatique',
    'AutoLogout': 'D\u00E9connexion automatique',
    'Show:': 'Afficher\u00A0:',
    'longesttimesandsystemstatistics': 'Temps les plus longs, statistiques de syst\u00E8me',
    'Please select the column of data': 'Veuillez choisir la colonne de donn\u00E9es que vous voulez',
    'rank your stores by': 'classer vos restaurants par',
    'minigoal': 'Obj.',
    'viewFranchise': 'Afficher les franchises',
    'franchiseHelp': "Choisissez d'inclure toutes donn�es de franchise partagees",
    'leaderboardgroups': 'Leaderboard Groupes',
    'leaderboardgroupManage': 'Gestion de groupe de classement',
    'leaderboardgroupsdetails': 'Details du groupe de classement',
    'addagroup': 'Ajouter un nouveau groupe',
    'groupname': 'Nom de groupe',
    'createdBy': 'Cree par',
    'createdDate': 'date creee',
    'deletegroup': 'Supprimer le ra�le',
    'groupdescription': 'Description du groupe',
    'storesingroup': 'Restaurants dans le groupe:',
    'manageleaderboardgroups': 'Groupes de Classement',
    'managereportgroups': 'Gérer la hiérarchie',
    'settingsStoresGroup': 'Groupe',
    'StoreSettingsLeaderboardGroup': 'Groupes de Classement',
    'StoreSettingsReportGroup': 'Groupes de rapports',
    'availablestores': 'Magasins disponibles',
    'youdonthavepermission': "Vous n'êtes pas autorisé à utiliser cette fonctionnalité",
    'noStores': "Pour utiliser cette fonction, vous devez d'abord enregistrer un zoom avec HME CLOUD.",
    'GroupNameTaken': 'Un Tableau de bord du même nom existe déjà. Veuillez créer un nom de Tableau de bord unique.',
    'Active groups require': 'Les groupes actifs nécessitent au moins 1 restaurant à choisir.',
    'Status is required': 'Statut requis.',
    'Group name may not be blank': 'Le nom du groupe ne doit pas être vide.',
    'Last Updated is empty': "Le groupe n'est pas valide: la dernière mise à jour est vide.",
    'Company not found': 'Groupe non valide: Société introuvable.',
    'Store list mismatch': "Le groupe n'est pas valide: incompatibilité de liste de restaurants.",
    'Update failed': "Le groupe n'est pas valide: la mise à jour a échoué.",
    'Company not found in Azure': 'Groupe non valide: Société introuvable dans Azure.',
    'Create Group failed': "Échec de la mise à jour/création d'un groupe.",
    'Store Group failed': 'Échec de la mise à jour du groupe de restaurants.',
    'Group is not valid': "Le groupe n'est pas valide.",
    'Inactive Group': 'Groupe inactif',
    'All stores will be removed from this group': 'Tous les restaurants seront supprimés de ce groupe',
    'OK': 'OK',
    'StoreNameColumn': 'Nom du Restaurant Colonne',
    'AddNewGroup': 'Ajouter un nouveau groupe',
    'ReportingGroupManagement': 'Gestion de groupe',
    'ReportingGroupDetails': 'Détails du groupe',
    'GroupName': 'Nom de groupe',
    'GroupDescription': 'Description du groupe',
    'AvailableGroupsStores': 'Groupes / restaurants disponibles',
    'GroupsStoresinGroup': 'Groupes / restaurants dans le groupe',
    'delete': 'supprimer',
    'navbarStores': 'Stores',
    'navbarSystems': 'Systèmes',
    'navbarUsers': 'Users',
    'navbarAccounts': 'Comptes',
    'navbarDistributers': 'Distributeurs',
    'navbarOptionSettings': 'Param\u00E8tres d\u2019affichage',
    'navbarOptionLeaderboard': 'Personnaliser le classement',
    'subNavbarStores': 'Stores',
    'subNavbarUsers': 'Utilisateurs',
    'subNavbarRoles': 'Les rôles',
    'subNavbarDashboard': 'Dashboard',
    'subNavbarReports': 'Reports',
    'subNavbarDeviceSettingsHistory': 'HISTORIQUE DES PARAM\u0201eTRES DE LAPPAREIL',
    'Groups': 'groupes',
    'requiredAccountId': 'Le numéro accountId est requis',
    'notRecordsFound': 'Aucun enregistrement trouvé',
    'requiredCreatedBy': 'createdBy number est requis',
    'saveTempplateSuccess': 'Le modèle a été enregistré avec succès',
    'saveTemplateFailure': "Échec de l'enregistrement du modèle",
    'invalidTemplateName': 'Modèle non valide',
    'deletedTemplate': 'Le modèle enregistré a été supprimé avec succès',
    'InvalidStoreId': 'Veuillez sélectionner un restaurants',
    'dateCannotbeEmpty': 'Veuillez sélectionner une date',
    'dateRangeInvalid': 'Plage de dates invalide. Pour les rapports de données brutes, sélectionnez un seul jour.',
    'invalidReportType': 'Paramètre Type de rapport non valide',
    'invalidEmail': 'Identifiant Email invalide non valide',
    'invalidRawCarStoreLength': 'Selection invalide. Veuillez ne pas sélectionner plus de 1 restaurants pour un rapport de données brutes',
    'advancedDateRangeInvalid': 'Plage de dates invalide. Pour les rapports sur les options avancées, sélectionnez une période de trois mois.',
    'dayPartInvalidDateRange': 'Plage de dates invalide. Pour les rapports Daypart, sélectionnez une période de deux semaines.',
    'weekInvalidDateRange': 'Plage de dates invalide. Pour les rapports hebdomadaires, sélectionnez une période de deux mois.',
    'dayInvalidDateRange': "Plage de dates invalide. Pour les rapports journaliers, sélectionnez une période d'un mois.",
    'fromDateGreaterThanToDate': 'Plage de dates invalide. La date de début ne peut pas être au-delà de la date de fin.',
    'advancedDateRangeDayPartInvalid': 'Plage de dates invalide. Pour les rapports sur les options avancées, sélectionnez une période de trois semaines.',
    'advancedDateRangeWeekInvalid': "Plage de dates invalide. Pour les rapports d'options avancées, sélectionnez une période de deux mois.",
    'storeSelectionInvalid': "La sélection du restaurants est invalide. Vous pouvez sélectionner jusqu'à 250 restaurants dans la liste ci- dessous.",
    'advancedDayInvalidDateRange': "Plage de dates invalide. Pour les rapports sur les options avancées, sélectionnez une période d'un mois.",
    'groupNameEmpty': 'Le nom du groupe ne peut pas être vide',
    'groupSuccess': 'Le groupe a été créé avec succès',
    'groupIdInvalid': 'GroupId incorrect',
    'invalidInput': "Les détails d'entrée incorrects ont fourni",
    'groupAlreadyExist': "Le groupe existe déjà dans le compte d'utilisateur",
    'groupUpdatesSuccess': 'Le groupe a été mis à jour avec succès',
    'noRecordsFoundForDelete': 'Aucun enregistrement trouvé pour la suppression',
    'recordsDeleted': 'Enregistrements supprimés avec succès',
    'recordDeleted': 'Enregistrement supprimé avec succès',
    'noDataForGivenId': "Aucune donnée trouvée pour l'identifiant donné",
    'invalidRequestBody': 'Corps de requête non valide',
    'groupCreationFailed': 'La création du groupe',
    'noDataForGivenName': 'Aucune donnée trouvée pour le prénom',
    'groupUpdationFailed': 'La mise à jour du groupe a échoué',
    'invalidTemplateId': 'Template Id incorrect',
    'createSuccess': 'Modèle de rapport créé avec succès',
    'createFailure': 'Impossible de créer un rapport',
    'deleteSuccess': 'Modèle de rapport supprimé avec succès',
    'deteleFailure': 'Impossible de supprimer le rapport',
    'firstNameEmpty': "L'utilisateur firstName ne peut pas être vide",
    'invalidUserUUID': 'Identifiant invalide',
    'usercreateSuccess': 'Utilisateur créé avec succès',
    'userAlreadyExist': "L'utilisateur existe déjà",
    'usercreateFailure': "La création d'utilisateur a échoué",
    'userupdatedSuccess': "Détails de l'utilisateur mis à jour",
    'userupdateFailure': 'La mise à jour des détails utilisateur a échoué',
    'userdeleteSuccess': 'Utilisateur supprimé avec succès',
    'userDeleteFailed': "La suppression de l'utilisateur a échoué",
    'rolecreateSuccess': 'Rôle de créer des succès',
    'roleAlreadyExist': 'Rôle existent déjà',
    'rolecreateFailure': ' Rôle de créer échoué',
    'roleupdatedSuccess': 'Rôle mis à jour le succès',
    'roleupdateFailure': 'Rôle échoué de mise à jour',
    'roledeleteSuccess': 'Rôle supprimer succès',
    'roleDeleteFailed': 'Rôle Suppression a échoué',
    'W-Avg': 'W-Avg',
    'Total Day': 'Total Jour',
    'Total Daypart': 'Total Partie du jour',
    'Total Week': 'Total de la semaine',
    'SubTotal': 'Sous total',
    'useragreementUrl': 'HMECLOUD_Terms_and_Conditions_fr.pdf',
    'agreementUrl': 'HMECLOUD_Terms_and_Conditions_fr.pdf',
    'privacypolicyUrl': 'HMECLOUD_Privacy_Policy_fr.pdf',
    'californiasupplyUrl': 'California_Transparency_Supply_Chains_Agreement_fr.pdf',
    'cookiepolicyUrl': 'HMECLOUD_Privacy_Policy_fr.pdf',
    'Jan': 'Janv',
    'Feb': 'Févr',
    'Mar': 'Mars',
    'Apr': 'Avril',
    'May': 'Mai',
    'Jun': 'Juin',
    'Jul': 'Juil',
    'Aug': 'Août',
    'Dec': 'Déc',

    'Janv': 'Jan',
    'Févr': 'Feb',
    'Mars': 'Mar',
    'Avril': 'Apr',
    'Mai': 'May',
    'Juin': 'Jun',
    'Juil': 'Jul',
    'Août': 'Aug',
    'Sept': 'Sept',
    'Oct': 'Oct',
    'Nov': 'Nov',
    'Déc': 'Dec',

    'janv': 'Janv',
    'févr': 'Févr',
    'mars': 'Mars',
    'avril': 'Avril',
    'mai': 'Mai',
    'juin': 'Juin',
    'juil': 'Juil',
    'août': 'Août',
    'déc': 'Déc',

    'jan': 'janv',
    'feb': 'févr',
    'mar': 'mars',
    'apr': 'avril',
    'may': 'mai',
    'jun': 'juin',
    'jul': 'juil',
    'aug': 'août',
    'sept': 'sept',
    'oct': 'oct',
    'nov': 'nov',
    'dec': 'déc',
    'Loading...': 'Chargement...',
    'Loading': 'Chargement',
    'Merge': 'Fusionner',
    'SelectSystem': 'Sélectionnez le (s) système (s)',
    'System': 'Système',
    'SelectTargetStore': 'Sélectionnez le restaurants cible',
    'EnterStoreNumber': 'Entrez le numéro de restaurants',
    'Search': 'Chercher',
    'Timezone': 'Fuseau horaire',
    'TandemLinesError': 'ERREUR: Les couloirs en tandem peuvent ne pas être sélectionnés dans plusieurs rapports de restaurant.',
    'TandemLanesStore': 'ERREUR: Les couloirs en tandem peuvent ne pas être sélectionnés dans plusieurs rapports de restaurant.',
    'errorTimeout': "Timeout: La requête n'a pas pu aboutir en 15000ms",
    'genericError': "Une erreur est survenue, veuillez contacter l'administrateur.",
    'openTime': "Entrez l'heure d'ouverture",
    'closeTime': "Entrez l'heure de fermeture",
    // Added -- New password and confirm password validation
    'newPasswordcontainblank': "Le nouveau mot de passe ne doit pas contenir d'espace.",
    'newPasswordinvalid': 'Nouveau mot de passe invalide.',
    'newPasswordsize': 'Le nouveau mot de passe doit comporter entre 8 et 16 caractères.',
    'newPassworduppercase': 'Le nouveau mot de passe doit contenir au moins 1 caractère majuscule.',
    'newPasswordlowercase': 'Le nouveau mot de passe doit contenir au moins 1 caractère minuscule.',
    'newPasswordnumber': 'Le nouveau mot de passe doit contenir au moins 1 numéro.',
    'confirmasswordcontainblank': "Le mot de passe de confirmation ne doit pas contenir d'espace vide.",
    'confirmpasswordinvalid': 'Mot de passe de confirmation invalide.',
    'confirmPasswordsize': 'Le mot de passe de confirmation doit comporter entre 8 et 16 caractères.',
    'confirmPassworduppercase': 'Confirmez que le mot de passe doit contenir au moins 1 caractère majuscule.',
    'confirmPasswordlowercase': 'Confirmez que le mot de passe doit contenir au moins 1 caractère minuscule.',
    'confirmPasswordnumber': 'Confirmez que le mot de passe doit contenir au moins 1 numéro.',
    'confirmPasswordcontainblank': "Le mot de passe de confirmation ne doit pas contenir d'espace vide.",
    'passwordmisMatch': 'Nouveau mot de passe et incompatibilité de mot de passe confirmée.',
    'distributors': 'distributeurs',
    'AddDistributor': 'Ajouter un distributeur',
    'percent': 'Objectif%',
    'storeNumber': 'Nombre',
    'storeRank': 'Rang',
    'storeName': 'Nom',
    'login_reminder': "Attention utilisateurs internes: Veuillez utiliser vos informations d'identification HME pour vous connecter au site Admin.",
    'seldistributor': '***Sélectionner un distributeur***:',
    'distributorName': 'Distributeur Nom',
    'HelpSubscription_type': 'Abonnement Type',
    'StartDate': 'Date de d\u00E9but',
    'EndDate': 'Date de fin',
    'hmeAvante':'HME Avante #:',
    'InvalidIdentificationCode':"Code d'identification invalide entré.",
    'DFASubmitVerification':'Soumettre la vérification',
    'IdentificationCodeLabel':"Code d'identification",
    'IdentificationCodeToolTip':"En tant que mesure de sécurité de compte ajoutée, vous devrez entrer le code d'identification que nous venons d'envoyer à votre adresse e-mail",
    'InvalidIdentificationCodeExpired':"Le code d'identification a expiré.",
    'InvalidIdentificationCodeInvalid':"Code d'identification incorrect entré.",
    'InvalidIdentificationCodeBlank':"Le code d'identification peut ne pas être vide.",
    'hmedashboardheaderrealtime': 'HME CLOUD REAL TIME DASHBOARD',
    'pullintextforexclude': 'Les données excluant stationnements',
    'userInActive': 'utilisateur est inactif',
    'storeTZSaveSuccess':'Le fuseau horaire a été enregistré.',
    'storeTZSaveError':'Store TZ pas ajouté.',
    'storeTZBlank':'Veuillez sélectionner le fuseau horaire.',
    'storenameblank':'Le nom du restaurant ne peut pas être vide.',
    'MustSelectStLeastOneSystem':"Vous devez sélectionner au moins un système.",
    'MustSelectTargetStore':"Vous devez sélectionner un restaurant cible.",
    'Mergeconfirmation':"Êtes-vous sûr de vouloir procéder ?",
    'ConfirmationRequired':"confirmation requise",
    'mergeActionRemove':"Cette action supprimera les systèmes suivants du CLOUD",
    'MergeTargetStoreOffline':'Le restaurant cible doit être hors ligne.',
    'storestatus':'Statut',
    'searchAll':"Rechercher tout",
    'SearchBrand':'Marque de recherche',
    'SearchStore':'Recherche restaurant',
    'SearchStoreName':'Rechercher le nom du restaurant',
    'SearchSerial':'Recherche en série',
    'SearchSystemVersion':'Version du système de recherche',
    'Serial':'En série',
    'RemoveSystem':'Supprimer le système',
    'RemoteSystemActions':'Actions du système distant',
    'homepageMyAccountDescriptionForAdmin':"Ajouter de nouveaux comptes ou Modifier les informations de compte existantes.",
    'homepageStoresDescriptionForAdmin':"Modifier les informations de contact pour les restaurants existants. Affichez les paramètres ZOOM pour chaque restaurants et accédez aux tableaux de bord en direct.",
    'homepageUsersDescriptionForAdmin':"Modifiez les informations de contact des utilisateurs existants et leur accès au restaurant.",
    'RegisteredDevices': 'Systèmes enregistrés',
    'StoreSettingsSerialno': 'Numéro De Série',
    'View': 'vue',
    'Details': 'd\u00E9tails',
    'SelectTimezone' : 'Sélectionnez un fuseau horaire',
    'storemergetext':"Pour fusionner et / ou supprimer des doublons",
    'clickhere':'cliquez ici.',
    'Master':'Maître',
    'Settings':'changements',
    'HMECLOUDOperatingInstructionsUrl':'HME_CLOUD_Operating_Instructions.pdf',
    'HMECLOUDOperatingInstructions':"HME CLOUD Mode d'emploi",
    'UnregisteredSystems':'Systèmes non enregistrés',
    'LBGroup': 'Defi du Leaderboard',
    'CreateLBGroup': 'Creer Defi du Leaderboard',
    'create': 'Creer',
    'Members':'Membres',
    'Showing':'Montrant',
    'of':'de',
    'results':'resultats',
    'Show':'Montrer',
    'itemsPerPage':'objets par page',
    'Edit':'Modifier',
    'Invite':'Inviter',
    'Assign':'Attribuer',
    'Remove':'Retirer',
    'JoinDate':'Date d\'Inscription',
    'MembersNumberOfStores':'Nombre de Restaurants',
    'MembersStatus':'Statut',
    'MembersIsAdmin':'Est Admin?',
    'MembersOf':"Membres de",
    'SendInvite':"Envoyer une Invitation",
    'toTheseStores':"a ces restaurants",
    'AssignedGroupOrLeaderboard':'Groupe assigne ou classement',
    'lbSelectedWillShowInStoresSelectedAbove':'*Le classement selectionne apparaitra dans les restaurants selectionnes ci-dessus',
    'selectedGroupWillReplaceCurrentStoresLB':'**le group selectionne remplacera le classement du restaurant actuel',
    'noStoresFound':'Aucun restaurants trouve.',
    'noGroupsFound':'Aucun defi trouve.',
    'noMembersFound':'Aucun membre trouve.',
    'confirmRemoval':'Confirmer le Retrait',
    'areYouSureYouWantToRemoveThisGroupMember':'Etes-vous sur de vouloir supprimer ce membre de defi?',
    'areYouSureYouWantToChangeMakeGroupMemberAnAdmin':'Êtes-vous sûr de vouloir faire de ce membre du groupe le propriétaire?',
    'invitationMailAlreadySentToUser':'Courrier d\'invitation déja envoyé a l\'utilisateur',
    'pleaseSelectALeaderBoardGroup':'Veuillez sélectionner un défi LeaderBoard!',
    'reject':'Rejeter',
    'confirmInvitation':'Confirmer l\'invitation',
    'pleaseClickBelowToAcceptInvitation':'Veuillez cliquer ci-dessous pour accepter l\'invitation!',
    'InvitedBy': 'Inviter par',
    'InvitedDate': 'Date d\'invitation',
    'AcceptInvitation': 'Accepter l\'invitation!',
    'MakeAdmin': 'Faire Proprietaire',
    'LeaderboardOwner': 'Proprietaire du Tableau de bord',
    'ChooseNewAdmin': 'Choisir un nouveau propriétaire',
    'pleaseEnterValidGroupTitle' : 'Veuillez entrer un titre de defi valide',
    'languagePreference' : 'Préférence de langue:',
    'youcannotdeleteadminsorsolemembers':'Vous ne pouvez pas supprimer des administrateurs ou des membres uniques des defis.',
    'French': 'Français',
    'English': 'Anglais',
    'InvalidEmail' : 'Email invalide',
    'InvalidEmailLanguage' : 'Langue de messagerie non valide',
    'selectcriteria':'Selectionner des Criteres',
    'actions':'Actes',
    'PasswordRequirements':'Exigences de mot de passe',
    'ResetPasswordLength':"La longueur du mot de passe doit être d'au moins huit (8) caractères et d'au plus seize (16) caractères.",
    'ResetPasswordBlank':"Le mot de passe ne peut pas contenir d'espaces.",
    'ResetPasswordGroup':"Le mot de passe doit contenir au moins un (1) caractère de chacun des trois (3) groupes ci-dessous:",
    'ResetPasswordGroupUpperCase':'Caractères majuscules anglais (A à Z)',
    'ResetPasswordGroupLowerCase':'Caractères anglais minuscules (a à z)',
    'ResetPasswordGroupNumerals':'Chiffres (0 à 9)',
    'NoDeviceFound': 'Aucun appareil trouvé',
    'homepageMyAccountPublic':'Mon compte',
    'settingsStoresNotavailable':'Indisponible',
    'removeStoreConfirm':"Êtes-vous sûr de vouloir supprimer le magasin sélectionné?",
    'warning':'ATTENTION',
    'actioncannotbeundone':"Cette action ne peut pas être annulée!",
    'storeRemoveSuccess':"Succès! Le magasin demandé a été supprimé.",
    'Upgradeyouraccount': 'Mettez à niveau votre compte vers le service Premium pour accéder à cette fonctionnalité',
    'Toupgradenow': 'Pour mettre à jour maintenant',
    'pleasecall': 'veuillez appeler',
    'DomesticSales': 'Les Ventes Intérieures',
    'Options': 'Options',
    'InternationalSales': "Ventes À L'International",
    'for': 'pour',
    'othercountries': "d'autres pays",
    'storeRemoveFailure':"Erreur! Quelque chose a mal tourné, veuillez réessayer votre demande.",
    'RemoveStore':'Supprimer magasin',
    'undergomaintenanceon':"Le HME CLOUD subira une maintenance sur",
    'undergomaintenanceontemporarilyunavailable':"L'affichage du site Web et du classement en magasin sera temporairement indisponible",
    'GMT':'GMT',
    'Zoomdeviceunreachablefordisconnect': 'Zoom device unreachable for disconnect. Please try your request again later.',
    'Zoomdeviceunreachable': 'Zoom device unreachable. Please try your request again later.',
    'BadDeviceID': 'Bad Device ID. The system administrator has been notified.',
    'NoDistributorsFound': 'Aucun distributeurs trouvés',
    'currentlyviewingasUser':"En cours de visualisation en tant qu'utilisateur",
    'Leaderboard':'Leaderboard',
    'AddLeaderboard':'Ajouter un Leaderboard',
    'Title':'Titre',
    'AddNewLeaderboard': 'Ajouter un Nouveau Classement',
    'LeaderboardOverview': 'Aperçu du classement',
    'LeaderboardName': 'Nom du classement',
    'LeaderboardDescription': 'Description du classement',
	  'LeaderboardContests':'Concours',
    'LeaderboardAwards':'Prix',
    'LeaderboardSmackTalk':'Smack Talk',
    'LeaderboardFeedback':'Retour d\'information',
    'Leaderboards': 'Tableau de bord du service-au-volant',
    'EditLeaderboardDetails':'Modifier les détails du classement',
    'StoresInLeaderboard':'Magasins dans le classement:',
    'LeaderboardDetails':'Détails du classement',
    'DefaultGroup': 'Groupe par Defaut',
    'SelectStores':'Selectionner des magasins:',
    'Submit':'Soumettre',
    'noLeaderboardSubscription':'La personne que vous avez invité à participer à votre tableau de classement ne dispose pas d\'un abonnement au tableau de classement.',
    'noEditLeaderboardPermission': 'La personne que vous avez invité à participer à votre tableau de classement n\'a pas l\'autorisation de recevoir des invitations au tableau de classement.',
    'inviteFailed': 'Échec de l\'invitation au classement',
    'inviteSuccess': 'Votre invitation a ete envoyee.',
    'notfound': 'La personne que vous avez invité à participer à votre classement n\'est pas un utilisateur valide de HME CLOUD.',
    'participatingAccounts':'Comptes Participants',
    'participatingUsers':'Utilisateurs Participants',
    'LBInviteSuccess1':'Félicitations, vous avez accepté de rejoindre le nouveau Tableau de bord du service-au-volant!',
    'LBInviteSuccess2':'Tous vos restaurants seront automatiquement déplacés vers le nouveau Tableau de bord du service-au-volant.',
    'LBInviteLoginNew':'Cliquez ici pour vous connecter au HME CLOUD et afficher votre Tableau de bord du service-au-volant:',
    'LBInviteLoginCurrent':'Cliquez ici pour vous connecter au HME CLOUD et afficher votre Tableau de bord du service-au-volant actuel:',
    'LBInviteReject':'Vous avez choisi de refuser l\'invitation à rejoindre un nouveau Tableau de bord du service-au-volant.',
    'LBInviteInvalidURL':'URL non valide/expirée',
    'LastUpgrade': 'Dernière mise à jour',
    'settingsSent': 'Settings Sent!',
    'NoStoresFound': 'Aucun magasin trouvé',
    'InternalErrorSomethingWentwrong': "Désolé, quelque chose s'est mal passé",
    'InternalErrorContactAdministrator': 'Désolé, veuillez contacter votre administrateur.',
    'InternalErrorTechnicalDetails': 'DÉTAILS TECHNIQUES',
    'InternalErrorError': 'Erreur',
    'InternalErrorGoBackToSite': 'RETOURNER',
    'MergeTargetStoreNoDeviceAssociated': "Aucun périphérique n'est associé au magasin cible.",
    'sameCompanyInvite': 'L\'invitation au Tableau de bord du service-au-volant ne doit pas être envoyée à un utilisateur du même compte.',
    'youAreNotAllowedToMakeThisUserAnOwner': 'Vous n\'etes pas autorise a faire de cet utilisateur un proprietaire',
    'acceptedInvite': 'Accepted Invite',
    'deniedInvite': 'Denied Invite',
    'companyExistsInLB':'La société invitée existe déjà dans le Tableau de bord du service-au-volant',
    'companyDeniedInLB':'La société invitée a déjà refusé une invitation.',
    'companyPendingInLB':'La société invitée a déjà reçu une invitation.',
    'selectStoresMsg':'Sélectionnez des magasins à ajouter à ce Tableau de bord du service-au-volant.',
    'NoParticipantStores': 'Aucun magasin',
    'declineInvitation': 'Êtes-vous sûr de vouloir refuser l\'invitation?',
    'selectNoStores': 'Êtes-vous sûr de vouloir ne sélectionner aucun magasin?',
    'storeSelection': 'Sélection de magasin',
    'declineInvitationHeader': 'Refuser l\'invitation',
    'inviteHello' : 'Hello,',
    'inviteMessage1' : ' vous a invité à participer à un Tableau de bord du service-au-volant!',
    'inviteConsent' : 'Consentement: ',
    'inviteMessage2' : 'Veuillez noter que si vous acceptez cette invitation, vous consentez à ce que les informations de classement du Tableau de bord du service-au-volant soient partagées avec ',
    'inviteMessage3' : ' et les d\'autres magasins dans le même Tableau de bord du service-au-volant.',
    'inviteMessage4' : 'En cliquant "Oui, j\'accepte et je sélectionnerai mes magasins" bouton ci-dessous vous demandera de sélectionner vos magasins pour ajouter le Tableau de bord du service-au-volant de l\'invité.',
    'inviteMessage5' : 'En cliquant sur "Non, je refuse l\'invitation", l\'invitation sera refusée. ',
    'inviteAcceptBtn1' : 'Oui, j\'accepte et je ',
    'inviteAcceptBtn2' : 'sélectionnerai mes magasins',
    'inviteRejectBtn1' : 'Non, je refuse',
    'inviteRejectBtn2' : ' l\'invitation',
    'inviteOptout' : 'Se désengager: ',
    'inviteMessage6' : 'Si, à un moment quelconque, vous souhaitez renvoyer vos magasins sur votre propre compte, vous pouvez vous connecter à HME CLOUD et les supprimer de la vue d\'ensemble du Tableau de bord du service-au-volant.',
    'Pending': 'En attendant',
    'Denied': 'Refusé',
    'Accepted': 'Accepté',
    'LeaderboardAd1' : 'Cette zone est destinée à l\'administration du Tableau de bord du service-au-volant HME, qui crée une compétition amicale entre magasins pour motiver les équipes et améliorer les performances! ',
    'LeaderboardAd2' : 'Vous n\'êtes pas abonné à ce service. Pour vous abonner, veuillez contacter votre représentant de compte HME ou appeler le service des ventes aux États-Unis: ',
    'LeaderboardAd3' : ' ou le service des ventes internationals: ',
    'LeaderboardAdPhone1' : '800.848.4468',
    'LeaderboardAdPhone2' : '+1 858.535.6000',
    'LeaderboardNoEditPerm' : 'L\'administrateur de compte de votre organisation ne vous a pas donné l\'autorisation d\'utiliser cette fonctionnalité. Si vous estimez que vous devriez avoir une permission, veuillez contacter votre administrateur de compte pour vous la fournir.',
    'ParticipatingStores':'Magasins participants',
    'ViewMyStoresOnly':'Mes magasins seulement',
    'Default':'  (D\u00E9faut)',
    'multipleEmailsErrorMessage': 'Vous ne pouvez pas entrer plus d\'une adresse électronique. Veuillez réviser l\'adresse e-mail entrée.',
    'enterSingleEmailMessage': 'Entrez une seule adresse email pour le compte que vous inviterez.'

  }
]
export default language


// WEBPACK FOOTER //
// ./src/components/Language/language.js